import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useIndicators } from "../../context/IndicatorContext";
import RangeBarSVG from "../RangeSvg/RangeBarSVG";
import { useMarketToggle } from "../../context/MarketContext";
import { useGlobalStock } from "../../hooks/useGlobalStock";
import { MdOutlineNoteAdd } from "react-icons/md";
import { FiRefreshCw } from "react-icons/fi";
import { useVariant } from "../../hooks/useVariant";
import { FaSpinner } from "react-icons/fa6";
import { TOOLTIPS } from "../../helper/tooltilData";
import { InfoTooltip } from "../Helper/InfoToolTip";
import Gauge from "../Gauge/Gauge";
import {
  FaRupeeSign,
  FaArrowUp,
  FaArrowDown,
  FaChartLine,
  FaChartBar,
  FaProjectDiagram,
} from "react-icons/fa";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  Legend,
  ComposedChart,
} from "recharts";
import { MdBarChart, MdShowChart } from "react-icons/md";
import GlobalCandleChart from "../GlobalCandleChart/GlobalCandleChart";
import { getTechnicalScores } from "../../helper/scoreHelper";
import OverallScoreGauge from "../OverallGauge/OverallGauge";

// const GlobalTest = () => {
//   const { companyCode } = useParams();
//   const {
//     getGlobalQuote,
//     globalQuote,
//     loading,
//     error,
//     getTargetPrice,
//     targetPrice,
//     getStockStatistics,
//     statsData,
//   } = useMarketIndicators();
//   const { market } = useMarketToggle();
//   const {
//     dailyRSI,
//     dailyMACD,
//     intradayRSI,
//     intradayMACD,
//     loadingIndicators,
//     fetchDailyIndicators,
//     fetchIntradayIndicators,
//     fetchReturnData,
//     returnData,
//     fetchMaData,
//     maData,
//     fetchHistData,
//     histData,
//   } = useIndicators();

//   const [lastUpdated, setLastUpdated] = useState("");
//   const [resistTimeFrame, setResistTimeFrame] = useState("day");
//   const { navigate } = useNavigate();
//   const [timeFrame, setTimeFrame] = useState("day");
//   const { type } = useParams();
//   const variant = useVariant();

//   useEffect(() => {
//     getGlobalQuote(companyCode);
//     fetchDailyIndicators(companyCode);
//     fetchIntradayIndicators(companyCode);
//     getTargetPrice(companyCode, market);
//     getStockStatistics(companyCode, market);
//     fetchReturnData(companyCode);
//     fetchMaData(companyCode);
//     fetchHistData(companyCode);
//   }, [companyCode]);
//   console.log("Global data", globalQuote);
//   const globalData = globalQuote?.data;
//   console.log("Stock data", statsData);
//   const statisticsData = statsData?.data?.body;
//   console.log("Global Quote data", globalData);
//   console.log("Global Hist Data", histData);
//   const finalHistData = histData;
//   console.log("FinalHistData", finalHistData);
//   const resDailyLow = finalHistData?.daily?.low;
//   console.log("resDailyLow", resDailyLow);
//   const resWeeklyLow = finalHistData?.weekly?.low;
//   const resDailyHigh = finalHistData?.daily?.high;
//   const resWeeklyHigh = finalHistData?.weekly?.high;
//   const resDailyClose = finalHistData?.daily?.close;
//   const resWeeklyClose = finalHistData?.weekly?.close;
//   const resDailyOpen = finalHistData?.daily?.open;
//   const resWeeklyOpen = finalHistData?.weekly?.open;
//   const calculatePivots = (open, high, low, close) => {
//     const range = high - low;

//     // Classic
//     const classicP = (high + low + close) / 3;
//     const classic = {
//       R3: high + 2 * (classicP - low),
//       R2: classicP + range,
//       R1: 2 * classicP - low,
//       P: classicP,

//       S1: 2 * classicP - high,
//       S2: classicP - range,
//       S3: low - 2 * (high - classicP),
//     };

//     // Fibonacci
//     const fib = {
//       R1: classicP + range * 0.382,
//       R2: classicP + range * 0.618,
//       R3: classicP + range * 1.0,
//       P: classicP,
//       S1: classicP - range * 0.382,
//       S2: classicP - range * 0.618,
//       S3: classicP - range * 1.0,
//     };

//     // Camarilla
//     const cam = {
//       R1: close + range * 1.0833,
//       R2: close + range * 1.1666,
//       R3: close + range * 1.25,
//       P: close,
//       S1: close - range * 1.0833,
//       S2: close - range * 1.1666,
//       S3: close - range * 1.25,
//     };

//     // Woodie
//     const woodieP = (high + low + 2 * close) / 4;
//     const woodie = {
//       R1: 2 * woodieP - low,
//       R2: woodieP + range,
//       R3: high + 2 * (woodieP - low),
//       P: woodieP,
//       S1: 2 * woodieP - high,
//       S2: woodieP - range,
//       S3: low - 2 * (high - woodieP),
//     };

//     // Demark
//     let demPivot;
//     if (close < open) {
//       demPivot = (high + 2 * low + close) / 4;
//     } else if (close > open) {
//       demPivot = (2 * high + low + close) / 4;
//     } else {
//       demPivot = (high + low + 2 * close) / 4;
//     }
//     const demark = {
//       P: demPivot,
//       R1: demPivot + range,
//       S1: demPivot - range,
//     };

//     return { classic, fib, cam, woodie, demark };
//   };

//   const resWeekly = calculatePivots(
//     resWeeklyOpen,
//     resWeeklyHigh,
//     resWeeklyLow,
//     resWeeklyClose,
//   );
//   const resDaily = calculatePivots(
//     resDailyOpen,
//     resDailyHigh,
//     resDailyLow,
//     resDailyClose,
//   );
//   console.log("ResWeekly", resWeekly);
//   console.log("ResDaily", resDaily);

//   // const companyName=globalData?.longName;
//   const quote = globalData?.[0];
//   console.log("quote data", quote);
//   console.log("target price", targetPrice);
//   console.log("Return data", returnData);
//   console.log("Ma data", maData);

//   const companyName = quote?.longName || quote?.shortName || "--";
//   // const type = quote.typeDisp || "Equity";
//   console.log("Companyname", companyName);
//   const last_price = quote?.regularMarketPrice;

//   const percentChange = quote?.regularMarketChangePercent
//     ? quote?.regularMarketChangePercent?.toFixed(2)
//     : "0.00";

//   const formatVolume = (volume) => {
//     if (volume == null) return "-";

//     const num = Number(volume);
//     if (!Number.isFinite(num)) return "-";

//     return num.toLocaleString("en-IN");
//   };
//   // useEffect(() => {
//   //   fetchAllIndicators(companyCode);
//   // }, [companyCode]);

//   // console.log("Day data", dailyData);
//   // console.log("Intraday data", intradayData);
//   console.log(
//     "Global indictaor",
//     dailyRSI,
//     dailyMACD,
//     intradayRSI,
//     intradayMACD,
//   );
//   const formatDate = (timestamp, mode) => {
//     const date = new Date(timestamp * 1000);

//     if (mode === "intraday") {
//       return date.toLocaleString("en-GB", {
//         day: "2-digit",
//         month: "2-digit",
//         year: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: false,
//       });
//     }

//     return date.toLocaleDateString("en-GB");
//   };

//   const transformIndicators = (rsiData, macdData, mode) => {
//     if (!rsiData?.data || !macdData?.data) return null;

//     return {
//       dates: macdData.data.map((item) => item.date),

//       indicators: {
//         rsi: rsiData.data.map((item) => ({
//           value: item.RSI,
//         })),

//         macd: macdData.data.map((item) => ({
//           macd: item.MACD,
//           signal: item.signal,
//           histogram: item.histogram,
//         })),
//       },
//     };
//   };

//   const dailyData = transformIndicators(dailyRSI, dailyMACD, "daily");

//   const intradayData = transformIndicators(
//     intradayRSI,
//     intradayMACD,
//     "intraday",
//   );
//   console.log("Dauky data", dailyData);
//   console.log("Intraday data", intradayData);
//   const indicators = dailyData?.indicators;
//   const indicatorsMin = intradayData?.indicators;
//   const getInterpretation = (indicators) => {
//     if (
//       !indicators ||
//       !Array.isArray(indicators.macd) ||
//       !Array.isArray(indicators.rsi) ||
//       indicators.macd.length === 0 ||
//       indicators.rsi.length === 0
//     ) {
//       return {
//         result: "Insufficient data",
//         color: "#fbbf24",
//         bgColor: "#FFF5CC",
//         prediction: "Neutral",
//       };
//     }

//     // ✅ Extract numeric values correctly
//     const latestRSIObj = indicators.rsi.at(-1);
//     const latestMACDObj = indicators.macd.at(-1);

//     const latestRSI = latestRSIObj?.value;
//     const macd = latestMACDObj?.macd;
//     const signal = latestMACDObj?.signal;
//     const histogram = latestMACDObj?.histogram;

//     if (
//       typeof latestRSI !== "number" ||
//       typeof macd !== "number" ||
//       typeof signal !== "number" ||
//       typeof histogram !== "number"
//     ) {
//       return {
//         result: "Indicator data incomplete",
//         color: "#fbbf24",
//         bgColor: "#FFF5CC",
//         prediction: "Neutral",
//       };
//     }

//     // --- RSI STATUS ---
//     let rsiStatus = "Neutral";
//     if (latestRSI >= 70) rsiStatus = "Overbought";
//     else if (latestRSI <= 30) rsiStatus = "Oversold";
//     else if (latestRSI > 50) rsiStatus = "Neutral-Bullish";
//     else rsiStatus = "Neutral-Bearish";

//     // --- MACD STATUS ---
//     let macdStatus = "Neutral";
//     if (macd > signal && histogram > 0) macdStatus = "Bullish";
//     else if (macd < signal && histogram < 0) macdStatus = "Bearish";

//     // --- STRONG ALIGNMENT ---
//     if (latestRSI > 55 && macdStatus === "Bullish") {
//       return {
//         result: "Strong Bullish Momentum (RSI & MACD aligned)",
//         color: "#249966",
//         bgColor: "#D4F7E6",
//         prediction: "Buy",
//       };
//     }

//     if (latestRSI < 45 && macdStatus === "Bearish") {
//       return {
//         result: "Strong Bearish Momentum (RSI & MACD aligned)",
//         color: "#f87171",
//         bgColor: "#FFE1E1",
//         prediction: "Sell",
//       };
//     }

//     // --- DIVERGENCE ---
//     if (
//       (latestRSI > 50 && macd < signal && histogram < 0) ||
//       (latestRSI < 50 && macd > signal && histogram > 0)
//     ) {
//       return {
//         result: "Divergence detected – Possible reversal",
//         color: "#fbbf24",
//         bgColor: "#FFF5CC",
//         prediction: "Neutral",
//       };
//     }

//     // --- EXTREMES ---
//     if (rsiStatus === "Overbought" && macdStatus === "Bullish") {
//       return {
//         result: "Overbought – Bullish but tiring",
//         color: "#f59e0b",
//         bgColor: "#FFF5CC",
//         prediction: "Sell",
//       };
//     }

//     if (rsiStatus === "Oversold" && macdStatus === "Bearish") {
//       return {
//         result: "Oversold – Bearish but rebound possible",
//         color: "#60a5fa",
//         bgColor: "#DBEAFE",
//         prediction: "Buy",
//       };
//     }

//     return {
//       result: "Neutral / Sideways Market",
//       color: "#9ca3af",
//       bgColor: "#E5E7EB",
//       prediction: "Neutral",
//     };
//   };

//   const { result, color, bgColor, prediction } = getInterpretation(indicators);
//   const {
//     result: result1,
//     color: color1,
//     prediction: prediction1,
//     bgColor: bgColor1,
//   } = getInterpretation(indicatorsMin);
//   const dailyDates = dailyData?.dates;
//   const intradayDates = intradayData?.dates;
//   const macdChartData =
//     Array.isArray(indicators?.macd) &&
//     indicators.macd.map((row, i) => ({
//       date: dailyDates?.[i] || null,
//       MACD: row.macd ?? 0,
//       signal: row.signal ?? 0,
//       histogram: row.histogram ?? 0,
//     }));
//   const macdChartDataMin =
//     Array.isArray(indicatorsMin?.macd) &&
//     indicatorsMin.macd.map((row, i) => ({
//       date: intradayDates?.[i] || null,
//       MACD: row.macd ?? 0,
//       signal: row.signal ?? 0,
//       histogram: row.histogram ?? 0,
//     }));
//   const selectedData =
//     timeFrame === "min"
//       ? Array.isArray(macdChartDataMin)
//         ? macdChartDataMin
//         : []
//       : Array.isArray(macdChartData)
//         ? macdChartData
//         : [];
//   console.log("Result from macd chart data", result, color, prediction);
//   const formatTwoDecimal = (value) => {
//     const num = Number(value);
//     return Number.isFinite(num) ? Math.round(num * 100) / 100 : null;
//   };
//   const volume = formatVolume(quote?.regularMarketVolume);
//   const open = formatTwoDecimal(quote?.regularMarketOpen);
//   const close = formatTwoDecimal(quote?.regularMarketPreviousClose);
//   const low = formatTwoDecimal(quote?.regularMarketDayLow);
//   const high = formatTwoDecimal(quote?.regularMarketDayHigh);
//   const fifty_low = formatTwoDecimal(quote?.fiftyTwoWeekLow);
//   const fifty_high = formatTwoDecimal(quote?.fiftyTwoWeekHigh);

//   // const fifty_low = quote?.fiftyTwoWeekLow.toFixed(2);
//   // const fifty_high = quote?.fiftyTwoWeekHigh.toFixed(2);
//   console.log("fiftytwo", fifty_low);
//   console.log("Target Price", targetPrice);
//   const target_low = targetPrice?.data?.target_low;
//   const target_high = targetPrice?.data?.target_high;
//   const target_price = targetPrice?.data?.target_price;
//   const peRatio = statsData?.data?.body?.forwardPE.fmt;
//   console.log("PE ratio is:-", peRatio);
//   const projectChange = (
//     ((target_price - last_price) / last_price) *
//     100
//   ).toFixed(2);
//   console.log("ProjectedChange", projectChange);
//   const latestDailyRSI = dailyData?.indicators?.rsi?.at(-1)?.value ?? null;

//   const latestDailyMACD = dailyData?.indicators?.macd?.at(-1) ?? null;
//   console.log("LatestRsi", latestDailyRSI);
//   console.log("Latest Macf", latestDailyMACD);
//   const latestRSI = latestDailyRSI;
//   const latestMacd = latestDailyMACD?.macd;
//   const calcReturn = (current, past) =>
//     past ? (((current - past) / past) * 100).toFixed(2) : null;

//   const returnsData = returnData?.closes;
//   const oneWeekReturn = calcReturn(last_price, returnsData?.oneWeek);
//   const oneMonthReturn = calcReturn(last_price, returnsData?.oneMonth);
//   const ytdReturn = calcReturn(last_price, returnsData?.ytd);
//   const oneYearReturn = calcReturn(last_price, returnsData?.oneYear);
//   const threeYearReturn = calcReturn(last_price, returnsData?.threeYear);
//   const fiveYearReturn = calcReturn(last_price, returnsData?.fiveYear);
//   const buildMARows = (ltp, maData = []) =>
//     maData.map((ma) => {
//       const smaTrend = ltp >= ma.sma ? "Buy" : "Sell";
//       const emaTrend = ltp >= ma.ema ? "Buy" : "Sell";

//       return {
//         name: ma.name,
//         smaValue: ma.sma,
//         emaValue: ma.ema,
//         smaTrend,
//         emaTrend,
//       };
//     });

//   const buildMASummary = (rows = []) => {
//     let buy = 0;
//     let sell = 0;

//     rows.forEach((r) => {
//       if (r.smaTrend === "Buy") buy++;
//       else sell++;

//       if (r.emaTrend === "Buy") buy++;
//       else sell++;
//     });

//     return {
//       finalBuy: buy,
//       finalSell: sell,
//     };
//   };

//   const finalMadata = maData?.movingAverages;
//   console.log("finalMadata", finalMadata);
//   const rows = buildMARows(last_price, maData?.movingAverages);
//   console.log("Rows data", rows);
//   const summary = buildMASummary(rows);
//   console.log("Summary", summary);
//   const curr = quote?.financialCurrency;
//   console.log("currency", curr);

//   const levels = [
//     { key: "R1", label: "First Resistance " },
//     { key: "R2", label: "Second Resistance" },
//     { key: "R3", label: "Third Resistance" },
//     { key: "P", label: "Pivot" },
//     { key: "S1", label: "First Support" },
//     { key: "S2", label: " Second Support" },
//     { key: "S3", label: " Third Support" },
//   ];
//   const resistanceDataToRender =
//     resistTimeFrame === "day" ? resDaily : resWeekly;
//   return (
//     <>
//       <div>
//         <div className="last-updated-head">
//           {lastUpdated && <span>As on {lastUpdated}</span>}
//           <FiRefreshCw
//             // onClick={handleManualRefresh}
//             size={18}
//             style={{
//               cursor: "pointer",
//               transition: "0.2s",
//             }}
//             onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
//             onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
//           />
//         </div>

//         {loading ? (
//           <p
//             style={{
//               fontSize: "1rem",
//               fontWeight: "700",

//               display: "flex",
//               gap: "1rem",
//             }}
//           >
//             Fetching Live data..
//             <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
//               <FaSpinner />
//             </span>
//           </p>
//         ) : (
//           quote && (
//             <>
//               <div className="stock-detail-card">
//                 <div className="analysis-container">
//                   <div className="analysis-header">
//                     <div className="analysis-header">
//                       <div className="analysis-head-name">
//                         <div className="analysis-head-div">
//                           <h2 className="stock-title">{companyName}</h2>
//                           <span className="stock-tag">{companyCode}</span>
//                         </div>

//                         <div className="price-chip-head">
//                           <div className="price-chip">
//                             <p className="label">LTP</p>
//                             <h3 className="value" style={{ color: "#2563eb" }}>
//                               {last_price} {curr}
//                             </h3>
//                           </div>

//                           <div className="price-chip">
//                             <p className="label">% Change</p>
//                             <h3
//                               className="value positive"
//                               style={{
//                                 color:
//                                   percentChange > 0 ? "#2fd18a" : "#f87171",
//                               }}
//                             >
//                               {percentChange}%
//                             </h3>
//                           </div>
//                           <div className="price-chip">
//                             <p className="label">Open</p>
//                             <h3 className="value">
//                               {open} {curr}
//                             </h3>
//                           </div>
//                           <div className="price-chip">
//                             <p className="label">Close</p>
//                             <h3 className="value">
//                               {close} {curr}
//                             </h3>
//                           </div>

//                           <div className="price-chip">
//                             <p className="label">Forecast Price</p>
//                             <h3
//                               className="value positive"
//                               style={{
//                                 color:
//                                   target_price > last_price
//                                     ? "#249966"
//                                     : "#f87171",
//                               }}
//                             >
//                               {target_price} {curr}
//                             </h3>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="action-buttons">
//                       <button className="btn-star">★</button>
//                     </div>
//                   </div>
//                   <div className="outer-insight-box">
//                     <div
//                       className="insight-box"
//                       style={{
//                         borderLeft:
//                           timeFrame === "min"
//                             ? `4px solid ${color1}`
//                             : `4px solid ${color}`,
//                       }}
//                     >
//                       <div className="insight-head-div">
//                         <p className="insight-head">Phro Trader Insights</p>

//                         <select
//                           name=""
//                           id=""
//                           value={timeFrame}
//                           onChange={(e) => setTimeFrame(e.target.value)}
//                           style={{
//                             background: "inherit",
//                             // color: "white",
//                             fontWeight: "600",
//                             color: "black",
//                             // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
//                             boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
//                             padding: "5px 7px",
//                             borderRadius: "10px",
//                           }}
//                         >
//                           <option value="min">Minute</option>
//                           <option value="day">Day</option>
//                         </select>
//                       </div>
//                       {/* <p className="insight-head">Phro Trader Insights</p> */}
//                       <div className="sub-insight">
//                         <div
//                           className="insight-text"
//                           style={{
//                             color: timeFrame === "min" ? color1 : color,
//                           }}
//                         >
//                           {timeFrame === "min" ? result1 : result}
//                         </div>
//                         <button
//                           className="insight-tag"
//                           style={{
//                             backgroundColor:
//                               timeFrame === "min" ? color1 : color,
//                             color: "white",
//                           }}
//                         >
//                           {timeFrame === "min" ? prediction1 : prediction}
//                         </button>
//                       </div>
//                     </div>{" "}
//                     {/* <div className="max-option">
//                       <div
//                         className="option-chain-div
//                 "
//                       >
//                         <p>Option Chain</p>
//                         <div className="option-chain-inner-div">
//                           <button
//                             className="rec-btn"
//                             onClick={() => {
//                               navigate(`/optionpage/${companyCode}`);
//                             }}
//                           >
//                             View
//                           </button>
//                         </div>
//                       </div>
//                       <div
//                         className="option-chain-div
//                 "
//                       >
//                         <p>Max Pain</p>
//                         <div className="option-chain-inner-div">
//                           <button
//                             className="rec-btn"
//                             onClick={() => {
//                               navigate(`/maxpainpage/${companyCode}`);
//                             }}
//                           >
//                             View
//                           </button>
//                         </div>
//                       </div>
//                     </div> */}
//                   </div>
//                   <div className="price-summary">
//                     <div className="price-scales">
//                       <div className="scale-block">
//                         <div className="label">Forecast Range</div>
//                         <div className="range-svg-wrapper">
//                           <RangeBarSVG
//                             title="Forecast Range"
//                             low={target_low}
//                             high={target_high}
//                             ltp={target_price}
//                             variant={variant}
//                             price={last_price}
//                             type="target"
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="price-scales">
//                       <div className="scale-block">
//                         <div className="label">Day Range</div>
//                         <div className="range-svg-wrapper">
//                           <RangeBarSVG
//                             title="Day Range"
//                             low={low}
//                             high={high}
//                             ltp={last_price}
//                             price={last_price}
//                             variant={variant}
//                             type="price"
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="price-scales">
//                       <div className="scale-block">
//                         <div className="label">52 Week Range</div>
//                         <div className="range-svg-wrapper">
//                           <RangeBarSVG
//                             title="52 Week Range"
//                             low={fifty_low}
//                             high={fifty_high}
//                             ltp={last_price}
//                             price={last_price}
//                             variant={variant}
//                             type="price"
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="factor-box">
//                     <h4>Wealth Creator/Destroyer</h4>
//                     <div>
//                       <div
//                         className="return-box"
//                         style={
//                           {
//                             // color: getColor(returns.oneYear),
//                           }
//                         }
//                       >
//                         <div className="return-label">
//                           <p className="return-p label">1W</p>
//                           <div
//                             className={`return-value ${
//                               oneWeekReturn > 0
//                                 ? "return-positive"
//                                 : "return-negative"
//                             }`}
//                           >
//                             {oneWeekReturn > 0 ? "+" : ""}
//                             {oneWeekReturn}%
//                           </div>
//                         </div>

//                         <div className="return-label">
//                           <p className="return-p label">1M</p>
//                           <div
//                             className={`return-value ${
//                               oneMonthReturn > 0
//                                 ? "return-positive"
//                                 : "return-negative"
//                             }`}
//                           >
//                             {oneMonthReturn > 0 ? "+" : ""}
//                             {oneMonthReturn}%
//                           </div>
//                         </div>
//                         <div className="return-label">
//                           <p className="return-p label">YTD</p>
//                           <div
//                             className={`return-value ${
//                               ytdReturn > 0
//                                 ? "return-positive"
//                                 : "return-negative"
//                             }`}
//                           >
//                             {ytdReturn > 0 ? "+" : ""}
//                             {ytdReturn}%
//                           </div>
//                         </div>
//                         <div className="return-label">
//                           {" "}
//                           <p className="return-p label">1Y</p>
//                           <div
//                             className={`return-value ${
//                               oneYearReturn > 0
//                                 ? "return-positive"
//                                 : "return-negative"
//                             }`}
//                           >
//                             {oneYearReturn > 0 ? "+" : ""}
//                             {oneYearReturn}%
//                           </div>
//                         </div>
//                         <div className="return-label">
//                           {" "}
//                           <p className="return-p label">3Y</p>
//                           <div
//                             className={`return-value ${
//                               threeYearReturn > 0
//                                 ? "return-positive"
//                                 : "return-negative"
//                             }`}
//                           >
//                             {threeYearReturn > 0 ? "+" : ""}
//                             {threeYearReturn}%
//                           </div>
//                         </div>
//                         <div className="return-label">
//                           <p className="return-p label">5Y</p>
//                           <div
//                             className={`return-value ${
//                               fiveYearReturn > 0
//                                 ? "return-positive"
//                                 : "return-negative"
//                             }`}
//                           >
//                             {fiveYearReturn > 0 ? "+" : ""}
//                             {fiveYearReturn}%
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="factor-wrapper">
//                     <div className="factor-box">
//                       <h4>Technical Factors</h4>
//                       <div className="inner-factor-box">
//                         <div className="factor-row">
//                           <p>RSI</p>
//                           <span
//                             style={{
//                               color: latestRSI > 0 ? "#2fd18a" : "#f87171",
//                             }}
//                           >
//                             {" "}
//                             {latestRSI?.toFixed(2)}
//                           </span>
//                         </div>
//                         <div className="factor-row">
//                           <p>MACD</p>
//                           <span className="positive">
//                             {latestMacd?.toFixed(2)}
//                           </span>
//                         </div>
//                         <div className="factor-row">
//                           <p>Volume</p>
//                           <span>{volume}</span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="factor-box">
//                       <h4>Fundamental Factors</h4>
//                       <div className="inner-factor-box">
//                         <div className="factor-row">
//                           <p className="label">% Upside</p>
//                           <span
//                             className="positive"
//                             style={{
//                               color: projectChange > 0 ? "#249966" : "#f87171",
//                             }}
//                           >
//                             {" "}
//                             {projectChange}%
//                           </span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Forecast Price</p>
//                           <span>{target_price}</span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">P/E Ratio</p>
//                           <span>{peRatio}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="val-1">
//                     <div className="factor-box">
//                       <h4>Valuation Measures</h4>
//                       <div className="inner-factor-box">
//                         {/* <div className="factor-row">
//                           <p className="label">Market Cap</p>
//                           <span>
//                             {" "}
//                             {formatMarketCapINR(marketCapData?.marketCap)}
//                           </span>
//                         </div> */}
//                         <div className="factor-row">
//                           <p className="label">Enterprise Value</p>
//                           <span> {statisticsData?.enterpriseValue?.fmt}</span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Forward P/E</p>
//                           <span>{statisticsData?.forwardPE?.fmt}</span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Price to Book</p>
//                           <span>{statisticsData?.priceToBook?.fmt}</span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Enterprise/Revenue</p>
//                           <span>
//                             {statisticsData?.enterpriseToRevenue?.fmt}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="valuation-div">
//                     {/* <div className="factor-box">
//                       <h4 style={{ borderBottom: "none" }}>Forecast Price</h4>

//                       <div className="price-scales">
//                         <div className="scale-block">
//                           <div
//                             className="range-svg-wrapper"
//                             style={{ marginTop: "10px" }}
//                           >
//                             <RangeBarSVG
//                               title="Forecast Range"
//                               low={tLow}
//                               high={tHigh}
//                               ltp={tMean}
//                               variant={variant}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div> */}

//                     <div className="factor-box">
//                       <h4>Profitability & Growth</h4>
//                       <div className="inner-factor-box">
//                         <div className="factor-row">
//                           <p className="label">Profit Margin</p>
//                           <span>{statisticsData?.profitMargins?.fmt}</span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Earnings Growth (QoQ)</p>
//                           <span>
//                             {statisticsData?.earningsQuarterlyGrowth?.fmt}
//                           </span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Trailing EPS</p>
//                           <span>{statisticsData?.trailingEps?.fmt}</span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Forward EPS</p>
//                           <span>{statisticsData?.forwardEps?.fmt}</span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="factor-box">
//                       <h4>Ownership & Risk</h4>
//                       <div className="inner-factor-box">
//                         <div className="factor-row">
//                           <p className="label">Insider Holding %</p>
//                           <span>
//                             {statisticsData?.heldPercentInsiders?.fmt}
//                           </span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Institutional Holding %</p>
//                           <span>
//                             {statisticsData?.heldPercentInstitutions?.fmt}
//                           </span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Float Shares</p>
//                           <span>{statisticsData?.floatShares?.fmt}</span>
//                         </div>
//                         <div className="factor-row">
//                           <p className="label">Shares Outstanding</p>
//                           <span>{statisticsData?.sharesOutstanding?.fmt}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="factor-box">
//                     <div className="ma-panel">
//                       <h4>Moving Averages</h4>

//                       <Gauge
//                         buy={summary?.finalBuy}
//                         sell={summary?.finalSell}
//                       />

//                       <table className="ma-table">
//                         <thead>
//                           <tr>
//                             <th>Name</th>
//                             <th>Simple</th>
//                             <th></th>
//                             <th>Exponential</th>
//                             <th></th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {rows?.map((row) => (
//                             <tr key={row?.name}>
//                               <td>
//                                 <span>{row?.name}</span>
//                               </td>

//                               <td>
//                                 <span className="ma-value">
//                                   {row?.smaValue.toFixed(2)}
//                                 </span>
//                               </td>
//                               <td>
//                                 <span
//                                   className={
//                                     row.smaTrend === "Buy"
//                                       ? "ma-trend-buy"
//                                       : "ma-trend-sell"
//                                   }
//                                 >
//                                   {row?.smaTrend}
//                                 </span>
//                               </td>

//                               <td>
//                                 <span className="ma-value">
//                                   {row?.emaValue?.toFixed(2)}
//                                 </span>
//                               </td>
//                               <td>
//                                 <span
//                                   className={
//                                     row?.emaTrend === "Buy"
//                                       ? "ma-trend-buy"
//                                       : "ma-trend-sell"
//                                   }
//                                 >
//                                   {row?.emaTrend}
//                                 </span>
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                   <div className="factor-box">
//                     <div>
//                       <h4>Pivot Table</h4>
//                       <span
//                         style={{
//                           display: "flex",
//                           justifyContent: "end",
//                           margin: "10px 0",
//                         }}
//                       >
//                         <div className="chart-select">
//                           <label>Interval</label>
//                           <select
//                             name=""
//                             id=""
//                             value={resistTimeFrame}
//                             onChange={(e) => setResistTimeFrame(e.target.value)}
//                             style={{
//                               background: "inherit",
//                               // color: "white",
//                               fontWeight: "600",
//                               color: "black",
//                               // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
//                               boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
//                               padding: "5px 7px",
//                               borderRadius: "10px",
//                             }}
//                           >
//                             <option value="week">Weekly</option>
//                             <option value="day">Day</option>
//                           </select>
//                         </div>
//                       </span>
//                     </div>

//                     <div className="pivot-container">
//                       <table className="pivot-table">
//                         <thead>
//                           <tr>
//                             <th>Pivot</th>
//                             <th>Classic</th>
//                             <th>Fibonacci</th>
//                             <th>Camarilla</th>
//                             <th>Woodie</th>
//                             <th>DM</th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {levels?.map((level) => (
//                             <tr key={level?.key}>
//                               <td data-label="Pivot">
//                                 {level?.key} {`(${level?.label})`}
//                               </td>

//                               <td data-label="Classic">
//                                 {resistanceDataToRender?.classic?.[
//                                   level?.key
//                                 ]?.toFixed(2) ?? "—"}
//                               </td>

//                               <td data-label="Fibonacci">
//                                 {resistanceDataToRender?.fib?.[
//                                   level?.key
//                                 ]?.toFixed(2) ?? "—"}
//                               </td>

//                               <td data-label="Camarilla">
//                                 {resistanceDataToRender?.cam?.[
//                                   level?.key
//                                 ]?.toFixed(2) ?? "—"}
//                               </td>

//                               <td data-label="Woodie">
//                                 {resistanceDataToRender?.woodie?.[
//                                   level?.key
//                                 ]?.toFixed(2) ?? "—"}
//                               </td>

//                               <td data-label="DM">
//                                 {resistanceDataToRender?.demark?.[
//                                   level?.key
//                                 ]?.toFixed(2) ?? "—"}
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {macdChartData && macdChartData.length > 0 && (
//                 <div className="macd-chart-graph">
//                   <div className="chart-top-heading">
//                     <h3>📊 MACD Line, Signal & Histogram</h3>
//                     <div className="chart-select">
//                       <label>Interval</label>
//                       <select
//                         name=""
//                         id=""
//                         value={timeFrame}
//                         onChange={(e) => setTimeFrame(e.target.value)}
//                         style={{
//                           background: "inherit",
//                           // color: "white",
//                           fontWeight: "600",
//                           color: "black",
//                           // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
//                           boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
//                           padding: "5px 7px",
//                           borderRadius: "10px",
//                         }}
//                       >
//                         <option value="min">Minute</option>
//                         <option value="day">Day</option>
//                       </select>
//                     </div>
//                   </div>

//                   <ResponsiveContainer width="100%" height={300}>
//                     <ComposedChart data={selectedData}>
//                       <CartesianGrid strokeDasharray="3 3" stroke="#374151" />

//                       {/* X-Axis */}
//                       {/* <XAxis
//                                               dataKey="date"
//                                               tickFormatter={(date) => {
//                                                 const d = parseISO(date);
//                                                 // Only show the month label on the 1st of each month
//                                                 if (format(d, "dd") === "01") {
//                                                   return format(d, "MMM"); // "May", "Jun", "Jul"
//                                                 }
//                                                 return ""; // hide all other ticks
//                                               }}
//                                               tick={{ fill: "#fff", fontWeight: "bold" }}
//                                               axisLine={{ stroke: "#fff" }}
//                                               tickLine={{ stroke: "#fff" }}
//                                             /> */}
//                       {/* <XAxis
//                                               dataKey="date"
//                                               tickFormatter={(date, index) => {
//                                                 if (!date) return "";

//                                                 try {
//                                                   const hasTime = date.includes(":");
//                                                   const d = new Date(date.replace(" ", "T"));
//                                                   // ensures consistent parsing
//                                                   console.log("D:", d);

//                                                   if (hasTime) {
//                                                     // ⏱ Case 1: Intraday data → show time every 30 minutes (roughly index % 15)
//                                                     return index % 15 === 0
//                                                       ? d.toLocaleTimeString("en-IN", {
//                                                           hour: "2-digit",
//                                                           minute: "2-digit",
//                                                           hour12: false,
//                                                         })
//                                                       : "";
//                                                   } else {
//                                                     // 📅 Case 2: Daily data → show date every 10 days
//                                                     return index % 10 === 0
//                                                       ? d.toLocaleDateString("en-IN", {
//                                                           day: "2-digit",
//                                                           month: "short",
//                                                         })
//                                                       : "";
//                                                   }
//                                                 } catch {
//                                                   return "";
//                                                 }
//                                               }}
//                                               tick={{ fill: "#fff", fontWeight: "bold" }}
//                                               axisLine={{ stroke: "#fff" }}
//                                               tickLine={{ stroke: "#fff" }}
//                                             /> */}
//                       {/* <XAxis
//                                               dataKey="date"
//                                               tickFormatter={(date, index) => {
//                                                 if (!date || typeof date !== "string") return "";
//                                                 try {
//                                                   const hasTime = date.includes(":");
//                                                   // const safeDate = date.replace(" ", "T");
//                                                   const d = new Date(date.replace(" ", "T"));
//                                                   // console.log("Safedate", safeDate);
//                                                   // const d = new Date(safeDate);
//                                                   // console.log("D", d);

//                                                   // if (isNaN(d.getTime())) return ""; // invalid date guard

//                                                   // Intraday → show every 30 mins
//                                                   if (hasTime) {
//                                                     const timeLabel =
//                                                       index % 15 === 0
//                                                         ? d.toLocaleTimeString("en-IN", {
//                                                             hour: "2-digit",
//                                                             minute: "2-digit",
//                                                             hour12: false,
//                                                           })
//                                                         : "";

//                                                     // console.log(`Tick ${index}:`, {
//                                                     //   date,
//                                                     //   formatted: timeLabel,
//                                                     // });
//                                                     return timeLabel;
//                                                   }

//                                                   // Daily → show every 10th day
//                                                   return index % 10 === 0
//                                                     ? d.toLocaleDateString("en-IN", {
//                                                         day: "2-digit",
//                                                         month: "short",
//                                                       })
//                                                     : "";
//                                                 } catch {
//                                                   return "";
//                                                 }
//                                               }}
//                                               tick={{
//                                                 // fill: "#fff",
//                                                 fontWeight: "bold",
//                                                 fontSize: 10,
//                                               }}
//                                               axisLine={{ stroke: "#fff" }}
//                                               tickLine={{ stroke: "#fff" }}
//                                             /> */}
//                       {/* <XAxis
//                         dataKey="date"
//                         tickFormatter={(date, index) => {
//                           if (!date || typeof date !== "string") return "";

//                           let d;

//                           // 🔴 APPLY FIX ONLY FOR MINUTE DATA
//                           if (timeFrame === "min") {
//                             // "7/1/2026, 9:15:00 am" → "7/1/2026 9:15:00 am"
//                             const safe = date.replace(",", "");
//                             d = new Date(safe);
//                           } else {
//                             // Daily data (already ISO or clean)
//                             d = new Date(date);
//                           }

//                           if (isNaN(d.getTime())) return "";

//                           // ⏱ INTRADAY FORMAT
//                           if (timeFrame === "min") {
//                             return index % 10 === 0
//                               ? d.toLocaleTimeString("en-IN", {
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                   hour12: false,
//                                 })
//                               : "";
//                           }

//                           // 📅 DAILY FORMAT
//                           // return index % 15 === 0
//                           //   ? d.toLocaleDateString("en-IN", {
//                           //       day: "2-digit",
//                           //       month: "short",
//                           //     })
//                           //   : "";
//                           // 📅 DAILY FORMAT (no Date parsing)
//                           if (index % 15 !== 0) return "";

//                           const datePart = date.split(",")[0]; // "28/11/2025"
//                           const [day, month] = datePart.split("/");

//                           const monthNames = [
//                             "Jan",
//                             "Feb",
//                             "Mar",
//                             "Apr",
//                             "May",
//                             "Jun",
//                             "Jul",
//                             "Aug",
//                             "Sep",
//                             "Oct",
//                             "Nov",
//                             "Dec",
//                           ];

//                           return `${day} ${monthNames[parseInt(month, 10) - 1]}`;
//                         }}
//                         tick={{ fontWeight: "bold", fontSize: 10 }}
//                         axisLine={{ stroke: "#fff" }}
//                         tickLine={{ stroke: "#fff" }}
//                       /> */}
//                       <XAxis
//                         dataKey="date"
//                         interval="preserveStartEnd"
//                         minTickGap={20}
//                         tickFormatter={(date, index) => {
//                           if (!date || typeof date !== "string") return "";

//                           let d;

//                           // 🔴 KEEP MINUTE LOGIC SAME
//                           if (timeFrame === "min") {
//                             const safe = date.replace(",", "");
//                             d = new Date(safe);

//                             if (isNaN(d.getTime())) return "";

//                             return index % 10 === 0
//                               ? d.toLocaleTimeString("en-IN", {
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                   hour12: false,
//                                 })
//                               : "";
//                           }

//                           // ✅ FIXED DAILY LOGIC (NO index filtering)
//                           const datePart = date.split(",")[0]; // "28/11/2025"
//                           const [day, month] = datePart.split("/");

//                           const monthNames = [
//                             "Jan",
//                             "Feb",
//                             "Mar",
//                             "Apr",
//                             "May",
//                             "Jun",
//                             "Jul",
//                             "Aug",
//                             "Sep",
//                             "Oct",
//                             "Nov",
//                             "Dec",
//                           ];

//                           return `${day} ${monthNames[parseInt(month, 10) - 1]}`;
//                         }}
//                         tick={{ fontWeight: "bold", fontSize: 10 }}
//                         axisLine={{ stroke: "#fff" }}
//                         tickLine={{ stroke: "#fff" }}
//                       />

//                       {/* Y-Axis */}
//                       <YAxis
//                         tick={{
//                           //  fill: "#fff",

//                           fontWeight: "bold",
//                           fontSize: 10,
//                         }}
//                         axisLine={{ stroke: "#fff" }}
//                         tickLine={{ stroke: "#fff" }}
//                       />

//                       {/* Tooltip */}
//                       {/* <Tooltip
//                                               contentStyle={{
//                                                 backgroundColor: "#1f2937",
//                                                 border: "none",
//                                               }}
//                                               labelStyle={{ color: "#fff", fontWeight: "bold" }}
//                                               itemStyle={{ color: "#fff" }}
//                                               labelFormatter={(date) => {
//                                                 // full date inside tooltip → "May 19, 2025"
//                                                 const d = parseISO(date);
//                                                 return format(d, "MMM dd, yyyy");
//                                               }}
//                                             /> */}
//                       <Tooltip
//                         contentStyle={{
//                           backgroundColor: "#1f2937",
//                           border: "none",
//                           color: "#fff",
//                         }}
//                         labelFormatter={(label) => {
//                           try {
//                             if (!label) return "";
//                             const hasTime = label.includes(":");
//                             const d = new Date(label.replace(" ", "T"));
//                             if (isNaN(d.getTime())) return label;

//                             if (hasTime) {
//                               // ⏱ Intraday case → show date + time
//                               return d.toLocaleString("en-IN", {
//                                 day: "2-digit",
//                                 month: "short",
//                                 hour: "2-digit",
//                                 minute: "2-digit",
//                                 hour12: false,
//                               });
//                             } else {
//                               // 📅 Daily case → show only date
//                               return d.toLocaleDateString("en-IN", {
//                                 day: "2-digit",
//                                 month: "short",
//                                 year: "numeric",
//                               });
//                             }
//                           } catch (err) {
//                             return label;
//                           }
//                         }}
//                         labelStyle={{ color: "#fff", fontWeight: "bold" }}
//                         itemStyle={{ color: "#fff" }}
//                       />

//                       {/* <Legend
//                                               wrapperStyle={{ color: "#fff", fontWeight: "bold" }}
//                                             /> */}
//                       <Legend
//                         wrapperStyle={{ fontWeight: "bold" }}
//                         payload={[
//                           {
//                             value: "Histogram (Bullish)", // custom label
//                             type: "square",
//                             color: "#2fd18a", // green for positive
//                           },
//                           {
//                             value: "Histogram (Bearish)",
//                             type: "square",
//                             color: "#f87171", // red for negative
//                           },
//                           {
//                             value: "MACD",
//                             type: "line",
//                             color: "#2563eb", // blue line
//                           },
//                           {
//                             value: "Signal",
//                             type: "line",
//                             color: "#f59e0b", // orange line
//                           },
//                         ]}
//                       />

//                       {/* Histogram bars */}
//                       {/* <Bar
//                                               dataKey="histogram"
//                                               name="Histogram"
//                                               // name={null}
//                                               barSize={20}
//                                               shape={(props) => {
//                                                 const { x, y, width, height, value } = props;
//                                                 return (
//                                                   <rect
//                                                     x={x}
//                                                     y={value >= 0 ? y : y - height}
//                                                     width={width}
//                                                     height={Math.abs(height)}
//                                                     fill={value >= 0 ? "#2fd18a" : "#f87171"}
//                                                   />
//                                                 );
//                                               }}
//                                             /> */}
//                       {/* <Bar
//                                   dataKey="histogram"
//                                   name="Histogram"
//                                   barSize={20}
//                                   shape={(props) => {
//                                     const { x, y, width, height, value } = props;
//                                     return (
//                                       <rect
//                                         x={x}
//                                         y={y}
//                                         width={width}
//                                         height={height}
//                                         fill={value >= 0 ? "#2fd18a" : "#f87171"}
//                                       />
//                                     );
//                                   }}
//                                 /> */}
//                       <Bar
//                         dataKey="histogram"
//                         name="Histogram"
//                         barSize={20}
//                         shape={(props) => {
//                           const { x, y, width, height, value } = props;

//                           const barHeight = Math.abs(height);

//                           return (
//                             <rect
//                               x={x}
//                               y={value >= 0 ? y : y - barHeight} // 🔥 key fix
//                               width={width}
//                               height={barHeight} // 🔥 absolute height
//                               fill={value >= 0 ? "#2fd18a" : "#f87171"}
//                             />
//                           );
//                         }}
//                       />

//                       {/* MACD Line */}
//                       <Line
//                         type="monotone"
//                         dataKey="MACD"
//                         stroke="#2563eb"
//                         strokeWidth={2}
//                         dot={false}
//                         name="MACD"
//                       />

//                       {/* Signal Line */}
//                       <Line
//                         type="monotone"
//                         dataKey="signal"
//                         stroke="#f59e0b"
//                         strokeWidth={2}
//                         dot={false}
//                         name="Signal"
//                       />
//                     </ComposedChart>
//                   </ResponsiveContainer>
//                 </div>
//               )}
//             </>
//           )
//         )}
//       </div>
//     </>
//   );
// };
// const safeNumber = (value) => {
//   if (value === null || value === undefined || value === "") return null;

//   const number = Number(String(value).replace(/,/g, ""));
//   return Number.isFinite(number) ? number : null;
// };

// const formatPrice = (value, digits = 2) => {
//   const number = safeNumber(value);
//   if (number === null) return "—";

//   return number.toLocaleString("en-US", {
//     minimumFractionDigits: digits,
//     maximumFractionDigits: digits,
//   });
// };

// const formatVolume = (value) => {
//   const number = safeNumber(value);
//   if (number === null) return "—";
//   return number.toLocaleString("en-US");
// };

// const formatPercent = (value) => {
//   const number = safeNumber(value);
//   if (number === null) return "—";
//   return `${number > 0 ? "+" : ""}${number.toFixed(2)}%`;
// };

// const formatTimestamp = (value) => {
//   if (!value) return "";

//   const numeric = safeNumber(value);
//   const date =
//     numeric !== null
//       ? new Date(numeric < 10_000_000_000 ? numeric * 1000 : numeric)
//       : new Date(value);

//   if (Number.isNaN(date.getTime())) return "";

//   return date.toLocaleString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: true,
//   });
// };

// const parseDate = (value) => {
//   if (!value) return null;

//   const numeric = safeNumber(value);
//   const date =
//     numeric !== null
//       ? new Date(numeric < 10_000_000_000 ? numeric * 1000 : numeric)
//       : new Date(value);

//   return Number.isNaN(date.getTime()) ? null : date;
// };

// const formatAxisDate = (value, timeFrame) => {
//   const date = parseDate(value);
//   if (!date) return "";

//   if (timeFrame === "min") {
//     return date.toLocaleTimeString("en-US", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false,
//     });
//   }

//   return date.toLocaleDateString("en-US", {
//     day: "2-digit",
//     month: "short",
//   });
// };

// const calculatePivots = (openValue, highValue, lowValue, closeValue) => {
//   const open = safeNumber(openValue);
//   const high = safeNumber(highValue);
//   const low = safeNumber(lowValue);
//   const close = safeNumber(closeValue);

//   if ([open, high, low, close].some((value) => value === null)) {
//     return null;
//   }

//   const range = high - low;
//   const classicP = (high + low + close) / 3;

//   const classic = {
//     R3: high + 2 * (classicP - low),
//     R2: classicP + range,
//     R1: 2 * classicP - low,
//     P: classicP,
//     S1: 2 * classicP - high,
//     S2: classicP - range,
//     S3: low - 2 * (high - classicP),
//   };

//   const fib = {
//     R3: classicP + range,
//     R2: classicP + range * 0.618,
//     R1: classicP + range * 0.382,
//     P: classicP,
//     S1: classicP - range * 0.382,
//     S2: classicP - range * 0.618,
//     S3: classicP - range,
//   };

//   const cam = {
//     R3: close + range * 1.25,
//     R2: close + range * 1.1666,
//     R1: close + range * 1.0833,
//     P: close,
//     S1: close - range * 1.0833,
//     S2: close - range * 1.1666,
//     S3: close - range * 1.25,
//   };

//   const woodieP = (high + low + 2 * close) / 4;
//   const woodie = {
//     R3: high + 2 * (woodieP - low),
//     R2: woodieP + range,
//     R1: 2 * woodieP - low,
//     P: woodieP,
//     S1: 2 * woodieP - high,
//     S2: woodieP - range,
//     S3: low - 2 * (high - woodieP),
//   };

//   let demarkP;
//   if (close < open) {
//     demarkP = (high + 2 * low + close) / 4;
//   } else if (close > open) {
//     demarkP = (2 * high + low + close) / 4;
//   } else {
//     demarkP = (high + low + 2 * close) / 4;
//   }

//   const demark = {
//     R3: null,
//     R2: null,
//     R1: demarkP + range,
//     P: demarkP,
//     S1: demarkP - range,
//     S2: null,
//     S3: null,
//   };

//   return { classic, fib, cam, woodie, demark };
// };

// const normalizeIndicators = (rsiResponse, macdResponse) => {
//   const rsiRows = Array.isArray(rsiResponse?.data) ? rsiResponse.data : [];
//   const macdRows = Array.isArray(macdResponse?.data) ? macdResponse.data : [];

//   return {
//     dates: macdRows.map((item) => item?.date),
//     rsi: rsiRows.map((item) => ({
//       value: safeNumber(item?.RSI ?? item?.rsi ?? item?.value),
//       date: item?.date,
//     })),
//     macd: macdRows.map((item) => ({
//       date: item?.date,
//       macd: safeNumber(item?.MACD ?? item?.macd),
//       signal: safeNumber(item?.signal),
//       histogram: safeNumber(item?.histogram),
//     })),
//   };
// };

// const getInterpretation = (indicatorData) => {
//   const latestRSI = indicatorData?.rsi?.at?.(-1)?.value;
//   const latestMACD = indicatorData?.macd?.at?.(-1);

//   const macd = latestMACD?.macd;
//   const signal = latestMACD?.signal;
//   const histogram = latestMACD?.histogram;

//   if (
//     latestRSI === null ||
//     latestRSI === undefined ||
//     macd === null ||
//     macd === undefined ||
//     signal === null ||
//     signal === undefined ||
//     histogram === null ||
//     histogram === undefined
//   ) {
//     return {
//       result: "Indicator data is not available yet",
//       prediction: "Neutral",
//       className: "stockpro-neutral",
//       color: "#64748b",
//     };
//   }

//   if (latestRSI > 55 && macd > signal && histogram > 0) {
//     return {
//       result: "Strong bullish momentum — RSI and MACD are aligned",
//       prediction: "Buy",
//       className: "stockpro-bull",
//       color: "#249966",
//     };
//   }

//   if (latestRSI < 45 && macd < signal && histogram < 0) {
//     return {
//       result: "Strong bearish momentum — RSI and MACD are aligned",
//       prediction: "Sell",
//       className: "stockpro-bear",
//       color: "#f87171",
//     };
//   }

//   if (
//     (latestRSI > 50 && macd < signal && histogram < 0) ||
//     (latestRSI < 50 && macd > signal && histogram > 0)
//   ) {
//     return {
//       result: "RSI and MACD are diverging — reversal risk is elevated",
//       prediction: "Neutral",
//       className: "stockpro-neutral",
//       color: "#f59e0b",
//     };
//   }

//   if (latestRSI >= 70) {
//     return {
//       result: "RSI is overbought — momentum is positive but stretched",
//       prediction: "Caution",
//       className: "stockpro-neutral",
//       color: "#f59e0b",
//     };
//   }

//   if (latestRSI <= 30) {
//     return {
//       result: "RSI is oversold — rebound potential is present",
//       prediction: "Watch",
//       className: "stockpro-neutral",
//       color: "#3b82f6",
//     };
//   }

//   return {
//     result: "Momentum is neutral or sideways",
//     prediction: "Neutral",
//     className: "stockpro-neutral",
//     color: "#64748b",
//   };
// };

// const getSignalClass = (value) => {
//   const normalized = String(value || "").toLowerCase();

//   if (
//     normalized.includes("buy") ||
//     normalized.includes("bull") ||
//     normalized.includes("positive")
//   ) {
//     return "stockpro-bull";
//   }

//   if (
//     normalized.includes("sell") ||
//     normalized.includes("bear") ||
//     normalized.includes("negative")
//   ) {
//     return "stockpro-bear";
//   }

//   return "stockpro-neutral";
// };

// const resampleMinuteMACD = (data, step) => {
//   if (!Array.isArray(data) || step <= 1) return data || [];

//   const output = [];

//   for (let index = 0; index < data.length; index += step) {
//     const chunk = data.slice(index, index + step);
//     if (!chunk.length) continue;

//     const last = chunk.at(-1);
//     output.push({
//       ...last,
//       histogram: chunk.reduce(
//         (sum, item) => sum + (safeNumber(item?.histogram) || 0),
//         0,
//       ),
//     });
//   }

//   return output;
// };

// const getPeriodKey = (date, interval) => {
//   if (interval === "1mo") {
//     return `${date.getFullYear()}-${date.getMonth() + 1}`;
//   }

//   if (interval === "3mo") {
//     return `${date.getFullYear()}-Q${Math.floor(date.getMonth() / 3) + 1}`;
//   }

//   const firstDay = new Date(date.getFullYear(), 0, 1);
//   const elapsedDays = Math.floor((date - firstDay) / 86_400_000);
//   const week = Math.ceil((elapsedDays + firstDay.getDay() + 1) / 7);
//   return `${date.getFullYear()}-W${week}`;
// };

// const resampleDailyMACD = (data, interval) => {
//   if (!Array.isArray(data) || interval === "1d") return data || [];

//   const groups = new Map();

//   data.forEach((row) => {
//     const date = parseDate(row?.date);
//     if (!date) return;

//     const key = getPeriodKey(date, interval);
//     if (!groups.has(key)) groups.set(key, []);
//     groups.get(key).push(row);
//   });

//   return Array.from(groups.values()).map((group) => {
//     const last = group.at(-1);

//     return {
//       ...last,
//       histogram: group.reduce(
//         (sum, item) => sum + (safeNumber(item?.histogram) || 0),
//         0,
//       ),
//     };
//   });
// };

// const RangeTrack = ({ low, high, current, currency }) => {
//   const lowNumber = safeNumber(low);
//   const highNumber = safeNumber(high);
//   const currentNumber = safeNumber(current);

//   const validRange =
//     lowNumber !== null &&
//     highNumber !== null &&
//     currentNumber !== null &&
//     highNumber > lowNumber;

//   const position = validRange
//     ? Math.min(
//         100,
//         Math.max(
//           0,
//           ((currentNumber - lowNumber) / (highNumber - lowNumber)) * 100,
//         ),
//       )
//     : 50;

//   return (
//     <div className="stockpro-range-box">
//       <div className="stockpro-range-labels">
//         <span>
//           {currency} {formatPrice(lowNumber)}
//         </span>
//         <span>
//           {currency} {formatPrice(highNumber)}
//         </span>
//       </div>

//       <div className="stockpro-range-track">
//         <div className="stockpro-range-dot" style={{ left: `${position}%` }} />
//       </div>

//       <p>
//         Current: {currency} {formatPrice(currentNumber)}
//       </p>
//     </div>
//   );
// };

// const HistogramBar = ({ x, y, width, height, value }) => {
//   const barHeight = Math.abs(height || 0);
//   const isPositive = safeNumber(value) >= 0;

//   return (
//     <rect
//       x={x}
//       y={isPositive ? y : y - barHeight}
//       width={width}
//       height={barHeight}
//       fill={isPositive ? "#2fd18a" : "#f87171"}
//     />
//   );
// };

// const GlobalTest = () => {
//   const { companyCode } = useParams();

//   const {
//     getGlobalQuote,
//     globalQuote,
//     loading,
//     error,
//     getTargetPrice,
//     targetPrice,
//     getStockStatistics,
//     statsData,
//   } = useMarketIndicators();

//   const { market } = useMarketToggle();

//   const {
//     dailyRSI,
//     dailyMACD,
//     intradayRSI,
//     intradayMACD,
//     loadingIndicators,
//     fetchDailyIndicators,
//     fetchIntradayIndicators,
//     fetchReturnData,
//     returnData,
//     fetchMaData,
//     maData,
//     fetchHistData,
//     histData,
//   } = useIndicators();

//   const [pageLoading, setPageLoading] = useState(true);
//   const [isRefreshing, setIsRefreshing] = useState(false);
//   const [loadedSymbol, setLoadedSymbol] = useState(null);
//   const [timeFrame, setTimeFrame] = useState("min");
//   const [chartInterval, setChartInterval] = useState("1m");
//   const [resistTimeFrame, setResistTimeFrame] = useState("day");
//   const [mobileTab, setMobileTab] = useState("details");
//   const [isMobile, setIsMobile] = useState(() =>
//     typeof window !== "undefined" ? window.innerWidth <= 768 : false,
//   );
//   const [lastUpdated, setLastUpdated] = useState("");

//   const loadGlobalData = async ({ silent = false } = {}) => {
//     if (!companyCode) return;

//     if (!silent) {
//       setPageLoading(true);
//       setLoadedSymbol(null);
//     } else {
//       setIsRefreshing(true);
//     }

//     try {
//       await Promise.allSettled([
//         getGlobalQuote(companyCode),
//         fetchDailyIndicators(companyCode),
//         fetchIntradayIndicators(companyCode),
//         getTargetPrice(companyCode, market),
//         getStockStatistics(companyCode, market),
//         fetchReturnData(companyCode),
//         fetchMaData(companyCode),
//         fetchHistData(companyCode),
//       ]);

//       setLoadedSymbol(companyCode);
//       setLastUpdated(new Date().toISOString());
//     } finally {
//       setPageLoading(false);
//       setIsRefreshing(false);
//     }
//   };

//   useEffect(() => {
//     loadGlobalData();
//     // Context methods are intentionally omitted to avoid reruns when providers
//     // recreate function references.
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [companyCode, market]);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     setChartInterval(timeFrame === "min" ? "1m" : "1d");
//   }, [timeFrame]);

//   const globalData = globalQuote?.data;
//   const rawQuote = Array.isArray(globalData) ? globalData[0] : globalData;
//   const quoteSymbol = String(rawQuote?.symbol || "").toUpperCase();
//   const requestedSymbol = String(companyCode || "").toUpperCase();
//   const quote =
//     !quoteSymbol || quoteSymbol === requestedSymbol ? rawQuote : null;
//   const statisticsData = statsData?.data?.body;

//   const companyName = quote?.longName || quote?.shortName || companyCode || "—";
//   const currency = quote?.financialCurrency || quote?.currency || "";

//   const lastPrice = safeNumber(quote?.regularMarketPrice);
//   const previousClose = safeNumber(quote?.regularMarketPreviousClose);
//   const open = safeNumber(quote?.regularMarketOpen);
//   const high = safeNumber(quote?.regularMarketDayHigh);
//   const low = safeNumber(quote?.regularMarketDayLow);
//   const weekLow = safeNumber(quote?.fiftyTwoWeekLow);
//   const weekHigh = safeNumber(quote?.fiftyTwoWeekHigh);
//   const volume = safeNumber(quote?.regularMarketVolume);

//   const directPercentChange = safeNumber(quote?.regularMarketChangePercent);
//   const percentChange =
//     directPercentChange !== null
//       ? directPercentChange
//       : lastPrice !== null && previousClose
//         ? ((lastPrice - previousClose) / previousClose) * 100
//         : null;

//   const directPriceChange = safeNumber(quote?.regularMarketChange);
//   const priceChange =
//     directPriceChange !== null
//       ? directPriceChange
//       : lastPrice !== null && previousClose !== null
//         ? lastPrice - previousClose
//         : null;

//   const quoteTime =
//     formatTimestamp(quote?.regularMarketTime) || formatTimestamp(lastUpdated);

//   const targetLow = safeNumber(targetPrice?.data?.target_low);
//   const targetHigh = safeNumber(targetPrice?.data?.target_high);
//   const targetPriceValue = safeNumber(targetPrice?.data?.target_price);

//   const projectedChange =
//     targetPriceValue !== null && lastPrice
//       ? ((targetPriceValue - lastPrice) / lastPrice) * 100
//       : null;

//   const dailyIndicators = useMemo(
//     () => normalizeIndicators(dailyRSI, dailyMACD),
//     [dailyRSI, dailyMACD],
//   );

//   const intradayIndicators = useMemo(
//     () => normalizeIndicators(intradayRSI, intradayMACD),
//     [intradayRSI, intradayMACD],
//   );

//   const dailyInsight = useMemo(
//     () => getInterpretation(dailyIndicators),
//     [dailyIndicators],
//   );

//   const intradayInsight = useMemo(
//     () => getInterpretation(intradayIndicators),
//     [intradayIndicators],
//   );

//   const activeInsight = timeFrame === "min" ? intradayInsight : dailyInsight;
//   const activeIndicators =
//     timeFrame === "min" ? intradayIndicators : dailyIndicators;

//   const latestRSI = activeIndicators?.rsi?.at?.(-1)?.value;
//   const latestMACDRow = activeIndicators?.macd?.at?.(-1);

//   const dailyMacdChartData = useMemo(
//     () =>
//       dailyIndicators.macd.map((row, index) => ({
//         date: row?.date || dailyIndicators?.dates?.[index],
//         MACD: row?.macd,
//         signal: row?.signal,
//         histogram: row?.histogram,
//       })),
//     [dailyIndicators],
//   );

//   const intradayMacdChartData = useMemo(
//     () =>
//       intradayIndicators.macd.map((row, index) => ({
//         date: row?.date || intradayIndicators?.dates?.[index],
//         MACD: row?.macd,
//         signal: row?.signal,
//         histogram: row?.histogram,
//       })),
//     [intradayIndicators],
//   );

//   const selectedChartData = useMemo(() => {
//     if (timeFrame === "min") {
//       const minuteStep = { "1m": 1, "3m": 3, "5m": 5 }[chartInterval] || 1;
//       return resampleMinuteMACD(intradayMacdChartData, minuteStep);
//     }

//     return resampleDailyMACD(dailyMacdChartData, chartInterval);
//   }, [timeFrame, chartInterval, dailyMacdChartData, intradayMacdChartData]);

//   const calculateReturn = (pastValue) => {
//     const past = safeNumber(pastValue);
//     if (lastPrice === null || past === null || past === 0) return null;
//     return ((lastPrice - past) / past) * 100;
//   };

//   const returnCloses = returnData?.closes;
//   const returnRows = [
//     { label: "1W", value: calculateReturn(returnCloses?.oneWeek) },
//     { label: "1M", value: calculateReturn(returnCloses?.oneMonth) },
//     { label: "YTD", value: calculateReturn(returnCloses?.ytd) },
//     { label: "1Y", value: calculateReturn(returnCloses?.oneYear) },
//     { label: "3Y", value: calculateReturn(returnCloses?.threeYear) },
//     { label: "5Y", value: calculateReturn(returnCloses?.fiveYear) },
//   ];

//   // const movingAverageRows = useMemo(() => {
//   //   const averages = Array.isArray(maData?.movingAverages)
//   //     ? maData.movingAverages
//   //     : [];

//   //   if (lastPrice === null) return [];

//   //   return averages
//   //     .map((item) => {
//   //       const sma = safeNumber(item?.sma);
//   //       const ema = safeNumber(item?.ema);

//   //       return {
//   //         name: item?.name || "—",
//   //         sma,
//   //         ema,
//   //         smaTrend:
//   //           sma === null ? "Neutral" : lastPrice >= sma ? "Buy" : "Sell",
//   //         emaTrend:
//   //           ema === null ? "Neutral" : lastPrice >= ema ? "Buy" : "Sell",
//   //       };
//   //     })
//   //     .filter((item) => item.sma !== null || item.ema !== null);
//   // }, [lastPrice, maData]);

//   // const movingAverageSummary = useMemo(() => {
//   //   let buy = 0;
//   //   let sell = 0;

//   //   movingAverageRows.forEach((row) => {
//   //     if (row.smaTrend === "Buy") buy += 1;
//   //     if (row.smaTrend === "Sell") sell += 1;
//   //     if (row.emaTrend === "Buy") buy += 1;
//   //     if (row.emaTrend === "Sell") sell += 1;
//   //   });

//   //   return { buy, sell, total: buy + sell };
//   // }, [movingAverageRows]);

//   const dailyPivots = useMemo(
//     () =>
//       calculatePivots(
//         histData?.daily?.open,
//         histData?.daily?.high,
//         histData?.daily?.low,
//         histData?.daily?.close,
//       ),
//     [histData],
//   );

//   const weeklyPivots = useMemo(
//     () =>
//       calculatePivots(
//         histData?.weekly?.open,
//         histData?.weekly?.high,
//         histData?.weekly?.low,
//         histData?.weekly?.close,
//       ),
//     [histData],
//   );

//   const activePivots = resistTimeFrame === "day" ? dailyPivots : weeklyPivots;

//   const nearestLevels = useMemo(() => {
//     const classic = activePivots?.classic;

//     if (!classic || lastPrice === null) {
//       return { resistance: null, support: null };
//     }

//     const resistanceValues = [classic.R1, classic.R2, classic.R3].filter(
//       (value) => safeNumber(value) !== null && value > lastPrice,
//     );

//     const supportValues = [classic.S1, classic.S2, classic.S3].filter(
//       (value) => safeNumber(value) !== null && value < lastPrice,
//     );

//     return {
//       resistance: resistanceValues.length
//         ? Math.min(...resistanceValues)
//         : null,
//       support: supportValues.length ? Math.max(...supportValues) : null,
//     };
//   }, [activePivots, lastPrice]);

//   const pivotLevels = [
//     { key: "R3", label: "Third Resistance" },
//     { key: "R2", label: "Second Resistance" },
//     { key: "R1", label: "First Resistance" },
//     { key: "P", label: "Pivot" },
//     { key: "S1", label: "First Support" },
//     { key: "S2", label: "Second Support" },
//     { key: "S3", label: "Third Support" },
//   ];

//   const getLevelStatus = (value) => {
//     const number = safeNumber(value);
//     if (number === null || lastPrice === null) return "—";
//     if (number > lastPrice) return "Above LTP";
//     if (number < lastPrice) return "Below LTP";
//     return "At LTP";
//   };

//   const getLevelPriority = (value) => {
//     const number = safeNumber(value);
//     if (number === null || !lastPrice) return "—";

//     const distance = Math.abs((number - lastPrice) / lastPrice) * 100;
//     if (distance <= 0.5) return "★★★";
//     if (distance <= 1.5) return "★★";
//     if (distance <= 3) return "★";
//     return "—";
//   };

//   const valuationRows = [
//     ["Enterprise Value", statisticsData?.enterpriseValue?.fmt],
//     ["Forward P/E", statisticsData?.forwardPE?.fmt],
//     ["Price to Book", statisticsData?.priceToBook?.fmt],
//     ["Enterprise / Revenue", statisticsData?.enterpriseToRevenue?.fmt],
//   ];

//   const profitabilityRows = [
//     ["Profit Margin", statisticsData?.profitMargins?.fmt],
//     ["Earnings Growth (QoQ)", statisticsData?.earningsQuarterlyGrowth?.fmt],
//     ["Trailing EPS", statisticsData?.trailingEps?.fmt],
//     ["Forward EPS", statisticsData?.forwardEps?.fmt],
//   ];

//   const ownershipRows = [
//     ["Insider Holding", statisticsData?.heldPercentInsiders?.fmt],
//     ["Institutional Holding", statisticsData?.heldPercentInstitutions?.fmt],
//     ["Float Shares", statisticsData?.floatShares?.fmt],
//     ["Shares Outstanding", statisticsData?.sharesOutstanding?.fmt],
//   ];

//   const combinedLoading =
//     pageLoading || loading || loadingIndicators || loadedSymbol !== companyCode;

//   const combinedError = error;

//   const movingAverages = useMemo(() => {
//     if (Array.isArray(maData?.movingAverages)) {
//       return maData.movingAverages;
//     }

//     if (Array.isArray(maData?.data?.movingAverages)) {
//       return maData.data.movingAverages;
//     }

//     if (Array.isArray(maData?.ma_data?.movingAverages)) {
//       return maData.ma_data.movingAverages;
//     }

//     return [];
//   }, [maData]);

//   const buildMARows = (ltp, averages = []) => {
//     if (ltp === null || !Array.isArray(averages)) return [];

//     return averages.map((ma) => {
//       const smaValue = safeNumber(ma?.sma);
//       const emaValue = safeNumber(ma?.ema);

//       return {
//         name: ma?.name || "-",
//         smaValue,
//         emaValue,

//         smaTrend:
//           smaValue === null ? "Neutral" : ltp >= smaValue ? "Buy" : "Sell",

//         emaTrend:
//           emaValue === null ? "Neutral" : ltp >= emaValue ? "Buy" : "Sell",
//       };
//     });
//   };

//   const movingAverageRows = useMemo(() => {
//     return buildMARows(lastPrice, movingAverages);
//   }, [lastPrice, movingAverages]);

//   const movingAverageSummary = useMemo(() => {
//     const finalBuy =
//       movingAverageRows.filter((row) => row.smaTrend === "Buy").length +
//       movingAverageRows.filter((row) => row.emaTrend === "Buy").length;

//     const finalSell =
//       movingAverageRows.filter((row) => row.smaTrend === "Sell").length +
//       movingAverageRows.filter((row) => row.emaTrend === "Sell").length;

//     return {
//       finalBuy,
//       finalSell,
//     };
//   }, [movingAverageRows]);

//   if (combinedLoading && !quote) {
//     return (
//       <p
//         style={{
//           fontSize: "1rem",
//           fontWeight: 700,
//           display: "flex",
//           alignItems: "center",
//           gap: "1rem",
//         }}
//       >
//         Fetching global market data...
//         <FaSpinner />
//       </p>
//     );
//   }

//   return (
//     <>
//       <div className="last-updated-head">
//         {quoteTime && <span>As on {quoteTime}</span>}

//         <FiRefreshCw
//           onClick={() => loadGlobalData({ silent: true })}
//           size={18}
//           style={{
//             cursor: isRefreshing ? "not-allowed" : "pointer",
//             transition: "0.2s",
//             opacity: isRefreshing ? 0.6 : 1,
//           }}
//         />
//       </div>

//       {combinedError && (
//         <div
//           style={{
//             marginTop: 20,
//             padding: 14,
//             borderLeft: "5px solid #dc2626",
//             background: "#fee2e2",
//             color: "#7f1d1d",
//             fontWeight: 600,
//             borderRadius: 8,
//           }}
//         >
//           {typeof combinedError === "string"
//             ? combinedError
//             : combinedError?.message || "Failed to load global market data"}
//         </div>
//       )}

//       {!combinedLoading && !quote && !combinedError && (
//         <div className="stockpro-card">
//           No global quote was returned for {companyCode}.
//         </div>
//       )}

//       {quote && (
//         <div className="stockpro-page">
//           {(!isMobile || mobileTab === "details") && (
//             <section className="stockpro-header">
//               <div className="stockpro-price-title">
//                 <div className="stockpro-head-block">
//                   <div className="stockpro-title-block">
//                     <h1>{companyName}</h1>
//                     <p className="stockpro-symbol stock-tag">{companyCode}</p>
//                     <span>
//                       {quote?.fullExchangeName ||
//                         quote?.exchange ||
//                         "Global Market"}
//                     </span>
//                   </div>

//                   <div className="stockpro-price-block">
//                     <h2>
//                       {currency} {formatPrice(lastPrice)}
//                     </h2>

//                     <p
//                       className={
//                         percentChange > 0
//                           ? "stockpro-green"
//                           : percentChange < 0
//                             ? "stockpro-red"
//                             : "stockpro-neutral"
//                       }
//                     >
//                       {percentChange > 0 ? "▲" : percentChange < 0 ? "▼" : "•"}{" "}
//                       {currency}{" "}
//                       {formatPrice(
//                         priceChange === null ? null : Math.abs(priceChange),
//                       )}
//                       <span> ({formatPercent(percentChange)})</span>
//                     </p>
//                   </div>
//                 </div>

//                 <div className="stockpro-header-metrics">
//                   {[
//                     ["LTP", lastPrice],
//                     ["Open", open],
//                     ["High", high],
//                     ["Low", low],
//                     ["Prev Close", previousClose],
//                     ["Volume", volume, true],
//                   ].map(([label, value, isVolume]) => (
//                     <div className="stockpro-metric" key={label}>
//                       <span>{label}</span>
//                       <b>
//                         {isVolume
//                           ? formatVolume(value)
//                           : `${currency} ${formatPrice(value)}`}
//                       </b>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </section>
//           )}

//           {(!isMobile || mobileTab === "details") && (
//             <section className="stockpro-signal-strip">
//               <div className="stockpro-insight-heading">
//                 <div>
//                   <h3>Quant Kubera Global Insights</h3>
//                   <p>{activeInsight.result}</p>
//                 </div>

//                 <div className="stockpro-tabs">
//                   <button
//                     className={timeFrame === "min" ? "active" : ""}
//                     onClick={() => setTimeFrame("min")}
//                   >
//                     Minute
//                   </button>
//                   <button
//                     className={timeFrame === "day" ? "active" : ""}
//                     onClick={() => setTimeFrame("day")}
//                   >
//                     Daily
//                   </button>
//                 </div>
//               </div>

//               <div className="signal-strip-main">
//                 <div className="signal-strip-inner">
//                   {[
//                     ["Momentum", activeInsight.prediction],
//                     [
//                       "RSI",
//                       latestRSI === null || latestRSI === undefined
//                         ? "—"
//                         : latestRSI.toFixed(2),
//                     ],
//                     [
//                       "MACD",
//                       latestMACDRow?.macd === null ||
//                       latestMACDRow?.macd === undefined
//                         ? "—"
//                         : latestMACDRow.macd.toFixed(2),
//                     ],
//                     [
//                       "MACD Signal",
//                       latestMACDRow?.signal === null ||
//                       latestMACDRow?.signal === undefined
//                         ? "—"
//                         : latestMACDRow.signal.toFixed(2),
//                     ],
//                     ["Target Upside", formatPercent(projectedChange)],
//                   ].map(([label, value]) => (
//                     <div className="stockpro-signal-chip" key={label}>
//                       <span>{label}</span>
//                       <b
//                         className={
//                           label === "Momentum"
//                             ? activeInsight.className
//                             : getSignalClass(value)
//                         }
//                       >
//                         {value ?? "—"}
//                       </b>
//                     </div>
//                   ))}
//                 </div>

//                 <div className="stockpro-actions">
//                   <button
//                     type="button"
//                     onClick={() => loadGlobalData({ silent: true })}
//                     disabled={isRefreshing}
//                   >
//                     {isRefreshing ? "Refreshing..." : "Refresh"}
//                   </button>
//                 </div>
//               </div>
//             </section>
//           )}

//           {isMobile && (
//             <div className="stock-mobile-tabs">
//               {[
//                 ["details", "Details"],
//                 ["technical", "Technical"],
//                 ["charts", "Charts"],
//                 ["fundamentals", "Fundamentals"],
//               ].map(([key, label]) => (
//                 <button
//                   key={key}
//                   className={mobileTab === key ? "active" : ""}
//                   onClick={() => setMobileTab(key)}
//                 >
//                   {label}
//                 </button>
//               ))}
//             </div>
//           )}

//           <section className="stockpro-grid">
//             <div className="stockpro-main">
//               {(!isMobile || mobileTab === "technical") && (
//                 <div className="stockpro-two-col">
//                   <section className="stockpro-card">
//                     <div className="stockpro-card-head">
//                       <h3>Technical Overview</h3>
//                       <b className={activeInsight.className}>
//                         {activeInsight.prediction}
//                       </b>
//                     </div>

//                     <div className="stockpro-level-list">
//                       <div>
//                         <span>RSI</span>
//                         <b>{latestRSI?.toFixed?.(2) || "—"}</b>
//                       </div>
//                       <div>
//                         <span>MACD</span>
//                         <b>{latestMACDRow?.macd?.toFixed?.(4) || "—"}</b>
//                       </div>
//                       <div>
//                         <span>Signal</span>
//                         <b>{latestMACDRow?.signal?.toFixed?.(4) || "—"}</b>
//                       </div>
//                       <div>
//                         <span>Histogram</span>
//                         <b
//                           className={
//                             safeNumber(latestMACDRow?.histogram) === null
//                               ? "stockpro-neutral"
//                               : safeNumber(latestMACDRow?.histogram) >= 0
//                                 ? "stockpro-green"
//                                 : "stockpro-red"
//                           }
//                         >
//                           {latestMACDRow?.histogram?.toFixed?.(4) || "—"}
//                         </b>
//                       </div>
//                     </div>
//                   </section>

//                   <section className="stockpro-card">
//                     <div className="stockpro-card-head">
//                       <h3>Key Levels</h3>
//                     </div>

//                     <div className="stockpro-level-list">
//                       <div>
//                         <span>Nearest Resistance</span>
//                         <b className="stockpro-red">
//                           {nearestLevels.resistance !== null
//                             ? `${currency} ${formatPrice(nearestLevels.resistance)}`
//                             : "—"}
//                         </b>
//                       </div>
//                       <div>
//                         <span>Nearest Support</span>
//                         <b className="stockpro-green">
//                           {nearestLevels.support !== null
//                             ? `${currency} ${formatPrice(nearestLevels.support)}`
//                             : "—"}
//                         </b>
//                       </div>
//                       <div>
//                         <span>Forecast Price</span>
//                         <b>
//                           {currency} {formatPrice(targetPriceValue)}
//                         </b>
//                       </div>
//                       <div>
//                         <span>Projected Upside</span>
//                         <b
//                           className={
//                             projectedChange === null
//                               ? "stockpro-neutral"
//                               : projectedChange >= 0
//                                 ? "stockpro-green"
//                                 : "stockpro-red"
//                           }
//                         >
//                           {formatPercent(projectedChange)}
//                         </b>
//                       </div>
//                     </div>
//                   </section>
//                 </div>
//               )}

//               {(!isMobile || mobileTab === "technical") && (
//                 <section className="stockpro-card">
//                   <div className="stockpro-card-head">
//                     <h3>Pivot Levels</h3>

//                     <div className="stockpro-tabs">
//                       <button
//                         className={resistTimeFrame === "day" ? "active" : ""}
//                         onClick={() => setResistTimeFrame("day")}
//                       >
//                         Daily
//                       </button>
//                       <button
//                         className={resistTimeFrame === "week" ? "active" : ""}
//                         onClick={() => setResistTimeFrame("week")}
//                       >
//                         Weekly
//                       </button>
//                     </div>
//                   </div>

//                   <div className="stockpro-table-wrap">
//                     <table className="stockpro-table">
//                       <thead>
//                         <tr>
//                           <th>Level</th>
//                           <th>Priority</th>
//                           <th>Status</th>
//                           <th>Classic</th>
//                           <th>Fibonacci</th>
//                           <th>Camarilla</th>
//                           <th>Woodie</th>
//                           <th>DM</th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {pivotLevels.map((level) => {
//                           const classic = activePivots?.classic?.[level.key];
//                           const fibonacci = activePivots?.fib?.[level.key];
//                           const camarilla = activePivots?.cam?.[level.key];
//                           const woodie = activePivots?.woodie?.[level.key];
//                           const demark = activePivots?.demark?.[level.key];

//                           return (
//                             <tr
//                               key={level.key}
//                               className={
//                                 level.key === "P" ? "stockpro-pivot-row" : ""
//                               }
//                             >
//                               <td>
//                                 <b>{level.key}</b> - {level.label}
//                               </td>
//                               <td>{getLevelPriority(classic)}</td>
//                               <td>
//                                 <span
//                                   className={
//                                     safeNumber(classic) === null
//                                       ? "stockpro-neutral"
//                                       : safeNumber(classic) > lastPrice
//                                         ? "stockpro-red"
//                                         : "stockpro-green"
//                                   }
//                                 >
//                                   {getLevelStatus(classic)}
//                                 </span>
//                               </td>
//                               <td>{formatPrice(classic)}</td>
//                               <td>{formatPrice(fibonacci)}</td>
//                               <td>{formatPrice(camarilla)}</td>
//                               <td>{formatPrice(woodie)}</td>
//                               <td>{formatPrice(demark)}</td>
//                             </tr>
//                           );
//                         })}
//                       </tbody>
//                     </table>
//                   </div>
//                 </section>
//               )}

//               {(!isMobile || mobileTab === "technical") && (
//                 <section className="stockpro-card">
//                   <div className="stockpro-card-head">
//                     <h3>Return Performance</h3>
//                   </div>

//                   <div className="stockpro-return-grid">
//                     {returnRows.map((item) => (
//                       <div className="stockpro-return-item" key={item.label}>
//                         <span>{item.label}</span>
//                         <b
//                           className={
//                             item.value === null
//                               ? "stockpro-neutral"
//                               : item.value >= 0
//                                 ? "stockpro-green"
//                                 : "stockpro-red"
//                           }
//                         >
//                           {formatPercent(item.value)}
//                         </b>
//                       </div>
//                     ))}
//                   </div>
//                 </section>
//               )}

//               {/* {(!isMobile || mobileTab === "technical") && (
//                 <section className="stockpro-card">
//                   <div className="stockpro-card-head">
//                     <h3>Moving Averages</h3>
//                     <span>
//                       Buy {movingAverageSummary.buy} / Sell{" "}
//                       {movingAverageSummary.sell}
//                     </span>
//                   </div>

//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns: `${
//                         movingAverageSummary.total
//                           ? (movingAverageSummary.buy /
//                               movingAverageSummary.total) *
//                             100
//                           : 50
//                       }% 1fr`,
//                       height: 8,
//                       borderRadius: 999,
//                       overflow: "hidden",
//                       background: "#fecaca",
//                       marginBottom: 18,
//                     }}
//                   >
//                     <div style={{ background: "#22c55e" }} />
//                     <div />
//                   </div>

//                   <div className="stockpro-table-wrap">
//                     <table className="stockpro-table">
//                       <thead>
//                         <tr>
//                           <th>Period</th>
//                           <th>SMA</th>
//                           <th>SMA Signal</th>
//                           <th>EMA</th>
//                           <th>EMA Signal</th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {movingAverageRows.length ? (
//                           movingAverageRows.map((row) => (
//                             <tr key={row.name}>
//                               <td>{row.name}</td>
//                               <td>{formatPrice(row.sma)}</td>
//                               <td>
//                                 <span className={getSignalClass(row.smaTrend)}>
//                                   {row.smaTrend}
//                                 </span>
//                               </td>
//                               <td>{formatPrice(row.ema)}</td>
//                               <td>
//                                 <span className={getSignalClass(row.emaTrend)}>
//                                   {row.emaTrend}
//                                 </span>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan={5}>
//                               Moving-average data is unavailable.
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </section>
//               )} */}
//               {(!isMobile || mobileTab === "technical") && (
//                 <section className="stockpro-card mobile-moving-average">
//                   <div className="stockpro-card-head">
//                     <h3>Moving Averages</h3>

//                     <span>
//                       Buy {movingAverageSummary?.finalBuy || 0} / Sell{" "}
//                       {movingAverageSummary?.finalSell || 0}
//                     </span>
//                   </div>

//                   <div className="stockpro-table-wrap">
//                     <Gauge
//                       buy={movingAverageSummary?.finalBuy}
//                       sell={movingAverageSummary?.finalSell}
//                     />

//                     <div className="mobile-ma-table-scroll">
//                       <table className="stockpro-table">
//                         <thead>
//                           <tr>
//                             <th>Period</th>
//                             <th>SMA</th>
//                             <th>SMA Signal</th>
//                             <th>EMA</th>
//                             <th>EMA Signal</th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {movingAverageRows.length > 0 ? (
//                             movingAverageRows.map((row) => (
//                               <tr key={row.name}>
//                                 <td>{row.name}</td>

//                                 <td>
//                                   {row.smaValue !== null
//                                     ? row.smaValue.toFixed(2)
//                                     : "—"}
//                                 </td>

//                                 <td>
//                                   <span
//                                     className={
//                                       row.smaTrend === "Buy"
//                                         ? "stockpro-green"
//                                         : row.smaTrend === "Sell"
//                                           ? "stockpro-red"
//                                           : "stockpro-neutral"
//                                     }
//                                   >
//                                     {row.smaTrend}
//                                   </span>
//                                 </td>

//                                 <td>
//                                   {row.emaValue !== null
//                                     ? row.emaValue.toFixed(2)
//                                     : "—"}
//                                 </td>

//                                 <td>
//                                   <span
//                                     className={
//                                       row.emaTrend === "Buy"
//                                         ? "stockpro-green"
//                                         : row.emaTrend === "Sell"
//                                           ? "stockpro-red"
//                                           : "stockpro-neutral"
//                                     }
//                                   >
//                                     {row.emaTrend}
//                                   </span>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan={5} style={{ textAlign: "center" }}>
//                                 Moving-average data is unavailable.
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </section>
//               )}

//               {(!isMobile || mobileTab === "charts") && (
//                 <section className="stockpro-card">
//                   <div className="stockpro-card-head">
//                     <h3>MACD Line, Signal and Histogram</h3>

//                     <div style={{ display: "flex", gap: 8 }}>
//                       <div className="stockpro-tabs">
//                         <button
//                           className={timeFrame === "min" ? "active" : ""}
//                           onClick={() => setTimeFrame("min")}
//                         >
//                           Minute
//                         </button>
//                         <button
//                           className={timeFrame === "day" ? "active" : ""}
//                           onClick={() => setTimeFrame("day")}
//                         >
//                           Daily
//                         </button>
//                       </div>

//                       <select
//                         value={chartInterval}
//                         onChange={(event) =>
//                           setChartInterval(event.target.value)
//                         }
//                       >
//                         {timeFrame === "min" ? (
//                           <>
//                             <option value="1m">1 Minute</option>
//                             <option value="3m">3 Minute</option>
//                             <option value="5m">5 Minute</option>
//                           </>
//                         ) : (
//                           <>
//                             <option value="1d">Daily</option>
//                             <option value="1w">Weekly</option>
//                             <option value="1mo">Monthly</option>
//                             <option value="3mo">Quarterly</option>
//                           </>
//                         )}
//                       </select>
//                     </div>
//                   </div>

//                   {selectedChartData.length ? (
//                     <ResponsiveContainer width="100%" height={340}>
//                       <ComposedChart data={selectedChartData}>
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis
//                           dataKey="date"
//                           minTickGap={32}
//                           tickFormatter={(value) =>
//                             formatAxisDate(value, timeFrame)
//                           }
//                         />
//                         <YAxis domain={["auto", "auto"]} />
//                         <Tooltip
//                           labelFormatter={(value) =>
//                             parseDate(value)?.toLocaleString("en-US") || value
//                           }
//                         />
//                         <Legend />
//                         <Bar
//                           dataKey="histogram"
//                           name="Histogram"
//                           barSize={12}
//                           shape={<HistogramBar />}
//                         />
//                         <Line
//                           type="monotone"
//                           dataKey="MACD"
//                           stroke="#2563eb"
//                           strokeWidth={2}
//                           dot={false}
//                           name="MACD"
//                         />
//                         <Line
//                           type="monotone"
//                           dataKey="signal"
//                           stroke="#f59e0b"
//                           strokeWidth={2}
//                           dot={false}
//                           name="Signal"
//                         />
//                       </ComposedChart>
//                     </ResponsiveContainer>
//                   ) : (
//                     <p>No MACD chart data is available.</p>
//                   )}
//                 </section>
//               )}
//             </div>

//             <aside className="stockpro-sidebar">
//               {(!isMobile || mobileTab === "details") && (
//                 <>
//                   <section className="stockpro-card">
//                     <div className="stockpro-card-head">
//                       <h3>Forecast Range</h3>
//                     </div>
//                     <RangeTrack
//                       low={targetLow}
//                       high={targetHigh}
//                       current={targetPriceValue}
//                       currency={currency}
//                     />
//                   </section>

//                   <section className="stockpro-card">
//                     <div className="stockpro-card-head">
//                       <h3>Day Range</h3>
//                     </div>
//                     <RangeTrack
//                       low={low}
//                       high={high}
//                       current={lastPrice}
//                       currency={currency}
//                     />
//                   </section>

//                   <section className="stockpro-card">
//                     <div className="stockpro-card-head">
//                       <h3>52 Week Range</h3>
//                     </div>
//                     <RangeTrack
//                       low={weekLow}
//                       high={weekHigh}
//                       current={lastPrice}
//                       currency={currency}
//                     />
//                   </section>
//                 </>
//               )}

//               {(!isMobile || mobileTab === "fundamentals") && (
//                 <>
//                   <section className="stockpro-card">
//                     <div className="stockpro-card-head">
//                       <h3>Fundamental Factors</h3>
//                     </div>

//                     <div className="stockpro-level-list">
//                       <div>
//                         <span>Projected Upside</span>
//                         <b
//                           className={
//                             projectedChange === null
//                               ? "stockpro-neutral"
//                               : projectedChange >= 0
//                                 ? "stockpro-green"
//                                 : "stockpro-red"
//                           }
//                         >
//                           {formatPercent(projectedChange)}
//                         </b>
//                       </div>
//                       <div>
//                         <span>Forecast Price</span>
//                         <b>
//                           {currency} {formatPrice(targetPriceValue)}
//                         </b>
//                       </div>
//                       <div>
//                         <span>Forward P/E</span>
//                         <b>{statisticsData?.forwardPE?.fmt || "—"}</b>
//                       </div>
//                     </div>
//                   </section>

//                   {[
//                     ["Valuation Measures", valuationRows],
//                     ["Profitability & Growth", profitabilityRows],
//                     ["Ownership & Risk", ownershipRows],
//                   ].map(([title, rows]) => (
//                     <section className="stockpro-card" key={title}>
//                       <div className="stockpro-card-head">
//                         <h3>{title}</h3>
//                       </div>

//                       <div className="stockpro-level-list">
//                         {rows.map(([label, value]) => (
//                           <div key={label}>
//                             <span>{label}</span>
//                             <b>{value || "—"}</b>
//                           </div>
//                         ))}
//                       </div>
//                     </section>
//                   ))}
//                 </>
//               )}
//             </aside>
//           </section>
//         </div>
//       )}
//     </>
//   );
// };

/* ────────────────────────────────────────────────────────────
 * NOTE: This file reuses Stock's "stockpro-*" CSS. If the styles
 * don't apply, make sure Stock.css is imported once globally, e.g.
 *   import "../Stock/Stock.css";
 * ──────────────────────────────────────────────────────────── */

const safeNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(number) ? number : null;
};

const formatPrice = (value, digits = 2) => {
  const number = safeNumber(value);
  if (number === null) return "—";
  return number.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

const formatVolume = (value) => {
  const number = safeNumber(value);
  if (number === null) return "—";
  return number.toLocaleString("en-US");
};

const formatPercent = (value) => {
  const number = safeNumber(value);
  if (number === null) return "—";
  return `${number > 0 ? "+" : ""}${number.toFixed(2)}%`;
};

const formatTimestamp = (value) => {
  if (!value) return "";
  const numeric = safeNumber(value);
  const date =
    numeric !== null
      ? new Date(numeric < 10_000_000_000 ? numeric * 1000 : numeric)
      : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

const parseDate = (value) => {
  if (!value) return null;
  const numeric = safeNumber(value);
  const date =
    numeric !== null
      ? new Date(numeric < 10_000_000_000 ? numeric * 1000 : numeric)
      : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatAxisDate = (value, timeFrame) => {
  const date = parseDate(value);
  if (!date) return "";
  if (timeFrame === "min") {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  }
  return date.toLocaleDateString("en-US", { day: "2-digit", month: "short" });
};

const calculatePivots = (openValue, highValue, lowValue, closeValue) => {
  const open = safeNumber(openValue);
  const high = safeNumber(highValue);
  const low = safeNumber(lowValue);
  const close = safeNumber(closeValue);
  if ([open, high, low, close].some((value) => value === null)) return null;

  const range = high - low;
  const classicP = (high + low + close) / 3;

  const classic = {
    R3: high + 2 * (classicP - low),
    R2: classicP + range,
    R1: 2 * classicP - low,
    P: classicP,
    S1: 2 * classicP - high,
    S2: classicP - range,
    S3: low - 2 * (high - classicP),
  };

  const fib = {
    R3: classicP + range,
    R2: classicP + range * 0.618,
    R1: classicP + range * 0.382,
    P: classicP,
    S1: classicP - range * 0.382,
    S2: classicP - range * 0.618,
    S3: classicP - range,
  };

  const cam = {
    R3: close + range * 1.25,
    R2: close + range * 1.1666,
    R1: close + range * 1.0833,
    P: close,
    S1: close - range * 1.0833,
    S2: close - range * 1.1666,
    S3: close - range * 1.25,
  };

  const woodieP = (high + low + 2 * close) / 4;
  const woodie = {
    R3: high + 2 * (woodieP - low),
    R2: woodieP + range,
    R1: 2 * woodieP - low,
    P: woodieP,
    S1: 2 * woodieP - high,
    S2: woodieP - range,
    S3: low - 2 * (high - woodieP),
  };

  let demarkP;
  if (close < open) demarkP = (high + 2 * low + close) / 4;
  else if (close > open) demarkP = (2 * high + low + close) / 4;
  else demarkP = (high + low + 2 * close) / 4;

  const demark = {
    R3: null,
    R2: null,
    R1: demarkP + range,
    P: demarkP,
    S1: demarkP - range,
    S2: null,
    S3: null,
  };

  return { classic, fib, cam, woodie, demark };
};

const normalizeIndicators = (rsiResponse, macdResponse) => {
  const rsiRows = Array.isArray(rsiResponse?.data) ? rsiResponse.data : [];
  const macdRows = Array.isArray(macdResponse?.data) ? macdResponse.data : [];
  return {
    dates: macdRows.map((item) => item?.date),
    rsi: rsiRows.map((item) => ({
      value: safeNumber(item?.RSI ?? item?.rsi ?? item?.value),
      date: item?.date,
    })),
    macd: macdRows.map((item) => ({
      date: item?.date,
      macd: safeNumber(item?.MACD ?? item?.macd),
      signal: safeNumber(item?.signal),
      histogram: safeNumber(item?.histogram),
    })),
  };
};

const getInterpretation = (indicatorData) => {
  const latestRSI = indicatorData?.rsi?.at?.(-1)?.value;
  const latestMACD = indicatorData?.macd?.at?.(-1);
  const macd = latestMACD?.macd;
  const signal = latestMACD?.signal;
  const histogram = latestMACD?.histogram;

  if (
    latestRSI === null ||
    latestRSI === undefined ||
    macd === null ||
    macd === undefined ||
    signal === null ||
    signal === undefined ||
    histogram === null ||
    histogram === undefined
  ) {
    return {
      result: "Indicator data is not available yet",
      prediction: "Neutral",
      className: "stockpro-neutral",
      color: "#64748b",
    };
  }

  if (latestRSI > 55 && macd > signal && histogram > 0) {
    return {
      result: "Strong bullish momentum — RSI and MACD are aligned",
      prediction: "Buy",
      className: "stockpro-bull",
      color: "#249966",
    };
  }

  if (latestRSI < 45 && macd < signal && histogram < 0) {
    return {
      result: "Strong bearish momentum — RSI and MACD are aligned",
      prediction: "Sell",
      className: "stockpro-bear",
      color: "#f87171",
    };
  }

  if (
    (latestRSI > 50 && macd < signal && histogram < 0) ||
    (latestRSI < 50 && macd > signal && histogram > 0)
  ) {
    return {
      result: "RSI and MACD are diverging — reversal risk is elevated",
      prediction: "Neutral",
      className: "stockpro-neutral",
      color: "#f59e0b",
    };
  }

  if (latestRSI >= 70) {
    return {
      result: "RSI is overbought — momentum is positive but stretched",
      prediction: "Caution",
      className: "stockpro-neutral",
      color: "#f59e0b",
    };
  }

  if (latestRSI <= 30) {
    return {
      result: "RSI is oversold — rebound potential is present",
      prediction: "Watch",
      className: "stockpro-neutral",
      color: "#3b82f6",
    };
  }

  return {
    result: "Momentum is neutral or sideways",
    prediction: "Neutral",
    className: "stockpro-neutral",
    color: "#64748b",
  };
};

const getSignalClass = (value) => {
  const normalized = String(value || "").toLowerCase();
  if (
    normalized.includes("buy") ||
    normalized.includes("bull") ||
    normalized.includes("positive")
  ) {
    return "stockpro-bull";
  }
  if (
    normalized.includes("sell") ||
    normalized.includes("bear") ||
    normalized.includes("negative")
  ) {
    return "stockpro-bear";
  }
  return "stockpro-neutral";
};

const resampleMinuteMACD = (data, step) => {
  if (!Array.isArray(data) || step <= 1) return data || [];
  const output = [];
  for (let index = 0; index < data.length; index += step) {
    const chunk = data.slice(index, index + step);
    if (!chunk.length) continue;
    const last = chunk.at(-1);
    output.push({
      ...last,
      histogram: chunk.reduce(
        (sum, item) => sum + (safeNumber(item?.histogram) || 0),
        0,
      ),
    });
  }
  return output;
};

const getPeriodKey = (date, interval) => {
  if (interval === "1mo") return `${date.getFullYear()}-${date.getMonth() + 1}`;
  if (interval === "3mo")
    return `${date.getFullYear()}-Q${Math.floor(date.getMonth() / 3) + 1}`;
  const firstDay = new Date(date.getFullYear(), 0, 1);
  const elapsedDays = Math.floor((date - firstDay) / 86_400_000);
  const week = Math.ceil((elapsedDays + firstDay.getDay() + 1) / 7);
  return `${date.getFullYear()}-W${week}`;
};

const resampleDailyMACD = (data, interval) => {
  if (!Array.isArray(data) || interval === "1d") return data || [];
  const groups = new Map();
  data.forEach((row) => {
    const date = parseDate(row?.date);
    if (!date) return;
    const key = getPeriodKey(date, interval);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(row);
  });
  return Array.from(groups.values()).map((group) => {
    const last = group.at(-1);
    return {
      ...last,
      histogram: group.reduce(
        (sum, item) => sum + (safeNumber(item?.histogram) || 0),
        0,
      ),
    };
  });
};

const RangeTrack = ({ low, high, current, currency }) => {
  const lowNumber = safeNumber(low);
  const highNumber = safeNumber(high);
  const currentNumber = safeNumber(current);

  const validRange =
    lowNumber !== null &&
    highNumber !== null &&
    currentNumber !== null &&
    highNumber > lowNumber;

  const position = validRange
    ? Math.min(
        100,
        Math.max(
          0,
          ((currentNumber - lowNumber) / (highNumber - lowNumber)) * 100,
        ),
      )
    : 50;

  return (
    <div className="stockpro-range-box">
      <div className="stockpro-range-labels">
        <span>
          {currency} {formatPrice(lowNumber)}
        </span>
        <span>
          {currency} {formatPrice(highNumber)}
        </span>
      </div>
      <div className="stockpro-range-track">
        <div className="stockpro-range-dot" style={{ left: `${position}%` }} />
      </div>
      <p>
        Current: {currency} {formatPrice(currentNumber)}
      </p>
    </div>
  );
};

const HistogramBar = ({ x, y, width, height, value }) => {
  const barHeight = Math.abs(height || 0);
  const isPositive = safeNumber(value) >= 0;
  return (
    <rect
      x={x}
      y={isPositive ? y : y - barHeight}
      width={width}
      height={barHeight}
      fill={isPositive ? "#2fd18a" : "#f87171"}
    />
  );
};

const GlobalTest = () => {
  const { companyCode } = useParams();

  const {
    getGlobalQuote,
    globalQuote,
    loading,
    error,
    getTargetPrice,
    targetPrice,
    getStockStatistics,
    statsData,
  } = useMarketIndicators();

  const { market } = useMarketToggle();

  // const {
  //   dailyRSI,
  //   dailyMACD,
  //   intradayRSI,
  //   intradayMACD,
  //   loadingIndicators,
  //   fetchDailyIndicators,
  //   fetchIntradayIndicators,
  //   fetchReturnData,
  //   returnData,
  //   fetchMaData,
  //   maData,
  //   fetchHistData,
  //   histData,
  // } = useIndicators();
  const {
    dailyRSI,
    dailyMACD,
    intradayRSI,
    intradayMACD,
    loadingIndicators,
    fetchDailyIndicators,
    fetchIntradayIndicators,
    fetchReturnData,
    returnData,
    fetchMaData,
    maData,
    fetchHistData,
    histData,
    fetchIntradayCandle,
    intradayCandle,
    candleLoading,
    candleError,

    globalSnapshot,
    globalSnapshotLoading,
    globalSnapshotError,
    fetchGlobalSnapshot,
  } = useGlobalStock();

  const [pageLoading, setPageLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [loadedSymbol, setLoadedSymbol] = useState(null);
  const [timeFrame, setTimeFrame] = useState("min");
  const [chartInterval, setChartInterval] = useState("1m");
  const [resistTimeFrame, setResistTimeFrame] = useState("day");
  const [mobileTab, setMobileTab] = useState("details");
  const [visibleCount, setVisibleCount] = useState(8);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );
  const [lastUpdated, setLastUpdated] = useState("");

  const loadGlobalData = async ({ silent = false } = {}) => {
    if (!companyCode) return;
    if (!silent) {
      setPageLoading(true);
      setLoadedSymbol(null);
    } else {
      setIsRefreshing(true);
    }
    try {
      // await Promise.allSettled([
      //   getGlobalQuote(companyCode),
      //   fetchDailyIndicators(companyCode),
      //   fetchIntradayIndicators(companyCode),
      //   getTargetPrice(companyCode, market),
      //   getStockStatistics(companyCode, market),
      //   fetchReturnData(companyCode),
      //   fetchMaData(companyCode),
      //   fetchHistData(companyCode),
      // ]);
      // await Promise.allSettled([
      //   getGlobalQuote(companyCode),
      //   fetchDailyIndicators(companyCode),
      //   fetchIntradayIndicators(companyCode),
      //   getTargetPrice(companyCode, market),
      //   getStockStatistics(companyCode, market),
      //   fetchReturnData(companyCode),
      //   fetchMaData(companyCode),
      //   fetchHistData(companyCode),
      //   fetchIntradayCandle(companyCode), // ← new
      // ]);
      await Promise.allSettled([
        fetchGlobalSnapshot(companyCode),

        // keep these temporarily if frontend still needs them
        getGlobalQuote(companyCode),

        fetchDailyIndicators(companyCode),

        getTargetPrice(companyCode, market),
        getStockStatistics(companyCode, market),

        fetchReturnData(companyCode),
        fetchMaData(companyCode),
        fetchHistData(companyCode),
      ]);
      setLoadedSymbol(companyCode);
      setLastUpdated(new Date().toISOString());
    } finally {
      setPageLoading(false);
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    loadGlobalData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyCode, market]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setChartInterval(timeFrame === "min" ? "1m" : "1d");
  }, [timeFrame]);

  const snapshot = globalSnapshot;

  const intraday = snapshot?.intraday;
  const latestRSI = snapshot?.rsi ?? intraday?.rsi ?? null;

  const latestMACD = snapshot?.macd ?? intraday?.macd ?? null;

  const latestMACDSignal =
    snapshot?.macd_signal ?? intraday?.macd_signal ?? null;

  const latestHistogram = snapshot?.histogram ?? intraday?.histogram ?? null;
  const vwap = snapshot?.vwap ?? intraday?.vwap ?? null;

  const vwapSignal = snapshot?.vwap_signal ?? intraday?.vwap_signal ?? null;
  const utSignal = snapshot?.ut_signal ?? intraday?.ut_signal ?? null;

  const bbSignal = snapshot?.bbawe_signal ?? intraday?.bbawe_signal ?? null;
  const prediction = snapshot?.prediction ?? intraday?.prediction ?? null;

  const predictionResult =
    snapshot?.prediction_result ?? intraday?.prediction_result ?? null;
  const smartMoney = snapshot?.smart_money ?? intraday?.smart_money ?? null;
  const intradayCandles =
    snapshot?.intraday_candles ?? intraday?.closeSeries ?? [];
  const globalData = globalQuote?.data;
  const rawQuote = Array.isArray(globalData) ? globalData[0] : globalData;
  const quoteSymbol = String(rawQuote?.symbol || "").toUpperCase();
  const requestedSymbol = String(companyCode || "").toUpperCase();
  const quote =
    !quoteSymbol || quoteSymbol === requestedSymbol ? rawQuote : null;
  const statisticsData = statsData?.data?.body;

  const companyName = quote?.longName || quote?.shortName || companyCode || "—";
  const currency = quote?.financialCurrency || quote?.currency || "";
  console.log("Madata", maData);
  const lastPrice = safeNumber(quote?.regularMarketPrice);
  const previousClose = safeNumber(quote?.regularMarketPreviousClose);
  const open = safeNumber(quote?.regularMarketOpen);
  const high = safeNumber(quote?.regularMarketDayHigh);
  const low = safeNumber(quote?.regularMarketDayLow);
  const weekLow = safeNumber(quote?.fiftyTwoWeekLow);
  const weekHigh = safeNumber(quote?.fiftyTwoWeekHigh);
  const volume = safeNumber(quote?.regularMarketVolume);

  const directPercentChange = safeNumber(quote?.regularMarketChangePercent);
  const percentChange =
    directPercentChange !== null
      ? directPercentChange
      : lastPrice !== null && previousClose
        ? ((lastPrice - previousClose) / previousClose) * 100
        : null;

  const directPriceChange = safeNumber(quote?.regularMarketChange);
  const priceChange =
    directPriceChange !== null
      ? directPriceChange
      : lastPrice !== null && previousClose !== null
        ? lastPrice - previousClose
        : null;

  const quoteTime =
    formatTimestamp(quote?.regularMarketTime) || formatTimestamp(lastUpdated);

  const targetLow = safeNumber(targetPrice?.data?.target_low);
  const targetHigh = safeNumber(targetPrice?.data?.target_high);
  const targetPriceValue = safeNumber(targetPrice?.data?.target_price);

  const projectedChange =
    targetPriceValue !== null && lastPrice
      ? ((targetPriceValue - lastPrice) / lastPrice) * 100
      : null;

  const dailyIndicators = useMemo(
    () => normalizeIndicators(dailyRSI, dailyMACD),
    [dailyRSI, dailyMACD],
  );

  const intradayIndicators = useMemo(
    () => normalizeIndicators(intradayRSI, intradayMACD),
    [intradayRSI, intradayMACD],
  );

  const dailyInsight = useMemo(
    () => getInterpretation(dailyIndicators),
    [dailyIndicators],
  );

  const intradayInsight = useMemo(
    () => getInterpretation(intradayIndicators),
    [intradayIndicators],
  );

  const activeInsight = timeFrame === "min" ? intradayInsight : dailyInsight;
  const activeIndicators =
    timeFrame === "min" ? intradayIndicators : dailyIndicators;

  // const latestRSI = activeIndicators?.rsi?.at?.(-1)?.value;
  // const latestMACDRow = activeIndicators?.macd?.at?.(-1);
  const latestMACDRow = {
    macd: snapshot?.macd,
    signal: snapshot?.macd_signal,
    histogram: snapshot?.histogram,
  };

  //new score data
  const scoreData = useMemo(() => {
    if (!snapshot) return null;

    return getTechnicalScores({
      rsi: latestRSI,

      macd: latestMACD,

      signal: latestMACDSignal,

      histogram: latestHistogram,

      ltp: lastPrice,

      vwap,

      smartMoneyScore: smartMoney?.score ?? 50,

      prediction,

      utSignal,

      bbSignal:
        bbSignal === "BUY"
          ? "Bullish"
          : bbSignal === "SELL"
            ? "Bearish"
            : bbSignal,
    });
  }, [
    snapshot,
    latestRSI,
    latestMACD,
    latestMACDSignal,
    latestHistogram,
    lastPrice,
    vwap,
    smartMoney,
    prediction,
    utSignal,
    bbSignal,
  ]);

  const getUTBotScore = (signal) => {
    if (!signal) {
      return {
        score: 50,
        label: "Neutral",
      };
    }

    const value = String(signal).toLowerCase();

    if (value.includes("bullish")) {
      return {
        score: 80,
        label: "Bullish",
      };
    }

    if (value.includes("bearish")) {
      return {
        score: 20,
        label: "Bearish",
      };
    }

    return {
      score: 50,
      label: "Neutral",
    };
  };

  const getBBScore = (signal) => {
    if (!signal) {
      return {
        score: 50,
        label: "Neutral",
      };
    }

    const value = String(signal).toLowerCase();

    if (value === "buy" || value === "bullish") {
      return {
        score: 80,
        label: "Bullish",
      };
    }

    if (value === "sell" || value === "bearish") {
      return {
        score: 20,
        label: "Bearish",
      };
    }

    return {
      score: 50,
      label: "Neutral",
    };
  };

  const rsiScore = scoreData?.rsiMacdScore ?? 50;

  const smartScore = smartMoney?.score ?? 50;

  const vwapScore = scoreData?.vwapScore ?? 50;

  const utScore = getUTBotScore(utSignal)?.score ?? 50;

  const bbScore = getBBScore(bbSignal)?.score ?? 50;

  const overallScore = scoreData?.overallScore ?? 50;

  const dailyMacdChartData = useMemo(
    () =>
      dailyIndicators.macd.map((row, index) => ({
        date: row?.date || dailyIndicators?.dates?.[index],
        MACD: row?.macd,
        signal: row?.signal,
        histogram: row?.histogram,
      })),
    [dailyIndicators],
  );

  const intradayMacdChartData = useMemo(
    () =>
      intradayIndicators.macd.map((row, index) => ({
        date: row?.date || intradayIndicators?.dates?.[index],
        MACD: row?.macd,
        signal: row?.signal,
        histogram: row?.histogram,
      })),
    [intradayIndicators],
  );

  const selectedChartData = useMemo(() => {
    if (timeFrame === "min") {
      const minuteStep = { "1m": 1, "3m": 3, "5m": 5 }[chartInterval] || 1;
      return resampleMinuteMACD(intradayMacdChartData, minuteStep);
    }
    return resampleDailyMACD(dailyMacdChartData, chartInterval);
  }, [timeFrame, chartInterval, dailyMacdChartData, intradayMacdChartData]);
  const selectedPriceData = useMemo(() => {
    const src = resistTimeFrame === "week" ? histData?.weekly : histData?.daily;
    if (!src?.close?.length) return [];

    // date array key varies by backend — adjust if yours differs
    const dates = src.date || src.dates || src.timestamp || [];

    return src.close.map((c, i) => ({
      date: dates[i] ?? i,
      close: safeNumber(c),
    }));
  }, [histData, resistTimeFrame]);
  // MACD crossovers (data exists for global, so this section is kept)
  const crossovers = useMemo(() => {
    const data = selectedChartData || [];
    const out = [];
    for (let i = 1; i < data.length; i++) {
      const prev = data[i - 1];
      const curr = data[i];
      if (
        prev?.MACD == null ||
        prev?.signal == null ||
        curr?.MACD == null ||
        curr?.signal == null
      )
        continue;
      if (prev.MACD < prev.signal && curr.MACD > curr.signal) {
        out.push({
          type: "BUY",
          date: curr.date,
          macd: curr.MACD,
          signal: curr.signal,
        });
      }
      if (prev.MACD > prev.signal && curr.MACD < curr.signal) {
        out.push({
          type: "SELL",
          date: curr.date,
          macd: curr.MACD,
          signal: curr.signal,
        });
      }
    }
    return out;
  }, [selectedChartData]);

  const calculateReturn = (pastValue) => {
    const past = safeNumber(pastValue);
    if (lastPrice === null || past === null || past === 0) return null;
    return ((lastPrice - past) / past) * 100;
  };

  const returnCloses = returnData?.closes;
  const returnRows = [
    { label: "1W", value: calculateReturn(returnCloses?.oneWeek) },
    { label: "1M", value: calculateReturn(returnCloses?.oneMonth) },
    { label: "YTD", value: calculateReturn(returnCloses?.ytd) },
    { label: "1Y", value: calculateReturn(returnCloses?.oneYear) },
    { label: "3Y", value: calculateReturn(returnCloses?.threeYear) },
    { label: "5Y", value: calculateReturn(returnCloses?.fiveYear) },
  ];

  const dailyPivots = useMemo(
    () =>
      calculatePivots(
        histData?.daily?.open,
        histData?.daily?.high,
        histData?.daily?.low,
        histData?.daily?.close,
      ),
    [histData],
  );

  const weeklyPivots = useMemo(
    () =>
      calculatePivots(
        histData?.weekly?.open,
        histData?.weekly?.high,
        histData?.weekly?.low,
        histData?.weekly?.close,
      ),
    [histData],
  );

  const activePivots = resistTimeFrame === "day" ? dailyPivots : weeklyPivots;

  const nearestLevels = useMemo(() => {
    const classic = activePivots?.classic;
    if (!classic || lastPrice === null) {
      return { resistance: null, support: null };
    }
    const resistanceValues = [classic.R1, classic.R2, classic.R3].filter(
      (value) => safeNumber(value) !== null && value > lastPrice,
    );
    const supportValues = [classic.S1, classic.S2, classic.S3].filter(
      (value) => safeNumber(value) !== null && value < lastPrice,
    );
    return {
      resistance: resistanceValues.length
        ? Math.min(...resistanceValues)
        : null,
      support: supportValues.length ? Math.max(...supportValues) : null,
    };
  }, [activePivots, lastPrice]);

  const pivotLevels = [
    { key: "R3", label: "Third Resistance" },
    { key: "R2", label: "Second Resistance" },
    { key: "R1", label: "First Resistance" },
    { key: "P", label: "Pivot" },
    { key: "S1", label: "First Support" },
    { key: "S2", label: "Second Support" },
    { key: "S3", label: "Third Support" },
  ];

  const getLevelStatus = (value) => {
    const number = safeNumber(value);
    if (number === null || lastPrice === null) return "—";
    if (number > lastPrice) return "Above LTP";
    if (number < lastPrice) return "Below LTP";
    return "At LTP";
  };

  const getLevelPriority = (value) => {
    const number = safeNumber(value);
    if (number === null || !lastPrice) return "—";
    const distance = Math.abs((number - lastPrice) / lastPrice) * 100;
    if (distance <= 0.5) return "★★★";
    if (distance <= 1.5) return "★★";
    if (distance <= 3) return "★";
    return "—";
  };

  const valuationRows = [
    ["Enterprise Value", statisticsData?.enterpriseValue?.fmt],
    ["Forward P/E", statisticsData?.forwardPE?.fmt],
    ["Price to Book", statisticsData?.priceToBook?.fmt],
    ["Enterprise / Revenue", statisticsData?.enterpriseToRevenue?.fmt],
  ];

  const profitabilityRows = [
    ["Profit Margin", statisticsData?.profitMargins?.fmt],
    ["Earnings Growth (QoQ)", statisticsData?.earningsQuarterlyGrowth?.fmt],
    ["Trailing EPS", statisticsData?.trailingEps?.fmt],
    ["Forward EPS", statisticsData?.forwardEps?.fmt],
  ];

  const ownershipRows = [
    ["Insider Holding", statisticsData?.heldPercentInsiders?.fmt],
    ["Institutional Holding", statisticsData?.heldPercentInstitutions?.fmt],
    ["Float Shares", statisticsData?.floatShares?.fmt],
    ["Shares Outstanding", statisticsData?.sharesOutstanding?.fmt],
  ];

  const combinedLoading =
    pageLoading || loading || loadingIndicators || loadedSymbol !== companyCode;
  const combinedError = globalSnapshotError;

  const movingAverages = useMemo(() => {
    if (Array.isArray(maData?.movingAverages)) return maData.movingAverages;
    if (Array.isArray(maData?.data?.movingAverages))
      return maData.data.movingAverages;
    if (Array.isArray(maData?.ma_data?.movingAverages))
      return maData.ma_data.movingAverages;
    return [];
  }, [maData]);

  const buildMARows = (ltp, averages = []) => {
    if (ltp === null || !Array.isArray(averages)) return [];
    return averages.map((ma) => {
      const smaValue = safeNumber(ma?.sma);
      const emaValue = safeNumber(ma?.ema);
      return {
        name: ma?.name || "-",
        smaValue,
        emaValue,
        smaTrend:
          smaValue === null ? "Neutral" : ltp >= smaValue ? "Buy" : "Sell",
        emaTrend:
          emaValue === null ? "Neutral" : ltp >= emaValue ? "Buy" : "Sell",
      };
    });
  };

  const movingAverageRows = useMemo(
    () => buildMARows(lastPrice, movingAverages),
    [lastPrice, movingAverages],
  );

  const movingAverageSummary = useMemo(() => {
    const finalBuy =
      movingAverageRows.filter((row) => row.smaTrend === "Buy").length +
      movingAverageRows.filter((row) => row.emaTrend === "Buy").length;
    const finalSell =
      movingAverageRows.filter((row) => row.smaTrend === "Sell").length +
      movingAverageRows.filter((row) => row.emaTrend === "Sell").length;
    return { finalBuy, finalSell };
  }, [movingAverageRows]);

  if (globalSnapshotLoading && !quote) {
    return (
      <p
        style={{
          fontSize: "1rem",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        Fetching global market data...
        <FaSpinner />
      </p>
    );
  }

  console.log("histData", histData);
  console.log("selectedPriceData", selectedPriceData);

  const getOverallSummary = () => {
    const bullishCount = [
      rsiScore >= 70,
      vwapScore >= 70,
      utScore >= 70,
      bbScore >= 70,
      smartScore >= 70,
    ].filter(Boolean).length;

    if (overallScore >= 80) {
      return {
        title: "Strong Bullish Setup",
        desc: `${bullishCount}/5 indicators are bullish. Momentum, trend, VWAP and smart money support upside continuation.`,
      };
    }

    if (overallScore >= 60) {
      return {
        title: "Bullish Setup",
        desc: `${bullishCount}/5 indicators support the trend. Buy on pullbacks is better than chasing.`,
      };
    }

    if (overallScore >= 40) {
      return {
        title: "Neutral Setup",
        desc: `${bullishCount}/5 indicators are bullish. Wait for better confirmation.`,
      };
    }

    if (overallScore >= 20) {
      return {
        title: "Bearish Setup",
        desc: "Weakness is visible. Avoid aggressive long positions.",
      };
    }

    return {
      title: "Strong Bearish Setup",
      desc: "Most indicators show downside pressure. Risk is high.",
    };
  };

  const overallSummary = getOverallSummary();

  const displayRSI =
    timeFrame === "min"
      ? latestRSI
      : (dailyIndicators?.rsi?.at?.(-1)?.value ?? null);

  const displayMACD =
    timeFrame === "min"
      ? latestMACD
      : (dailyIndicators?.macd?.at?.(-1)?.macd ?? null);

  const displayPrediction =
    timeFrame === "min" ? prediction : dailyInsight?.prediction;

  const displayPredictionResult =
    timeFrame === "min" ? predictionResult : dailyInsight?.result;

  const vwapDiff =
    snapshot?.vwap_diff ??
    (lastPrice !== null && vwap !== null ? lastPrice - vwap : null);

  const vwapPercent =
    snapshot?.vwap_percent ??
    (vwapDiff !== null && vwap ? (vwapDiff / vwap) * 100 : null);

  // same 0.1% VWAP stop-buffer style as Stock UI
  const vwapStopLoss = vwap !== null ? vwap * 0.999 : null;

  const getScoreTheme = (score = 50) => {
    if (score >= 80) {
      return {
        bg: "#dcfce7",
        border: "#86efac",
        circle: "#16a34a",
        text: "#15803d",
      };
    }

    if (score >= 60) {
      return {
        bg: "#ecfdf5",
        border: "#bbf7d0",
        circle: "#22c55e",
        text: "#249966",
      };
    }

    if (score >= 45) {
      return {
        bg: "#fefce8",
        border: "#fde68a",
        circle: "#eab308",
        text: "#ca8a04",
      };
    }

    if (score >= 30) {
      return {
        bg: "#fef2f2",
        border: "#fecaca",
        circle: "#ef4444",
        text: "#dc2626",
      };
    }

    return {
      bg: "#fee2e2",
      border: "#fca5a5",
      circle: "#dc2626",
      text: "#991b1b",
    };
  };

  const rsiTheme = getScoreTheme(rsiScore);
  const smartTheme = getScoreTheme(smartScore);
  const vwapTheme = getScoreTheme(vwapScore);
  const utTheme = getScoreTheme(utScore);
  const bbTheme = getScoreTheme(bbScore);
  const overallTheme = getScoreTheme(overallScore);

  return (
    <>
      <div className="last-updated-head">
        {quoteTime && <span>As on {quoteTime}</span>}
        <FiRefreshCw
          onClick={() => loadGlobalData({ silent: true })}
          size={18}
          style={{
            cursor: isRefreshing ? "not-allowed" : "pointer",
            transition: "0.2s",
            opacity: isRefreshing ? 0.6 : 1,
          }}
        />
      </div>

      {globalSnapshotError && (
        <div
          style={{
            marginTop: 20,
            padding: 14,
            borderLeft: "5px solid #dc2626",
            background: "#fee2e2",
            color: "#7f1d1d",
            fontWeight: 600,
            borderRadius: 8,
          }}
        >
          {/* {typeof combinedError === "string"
            ? combinedError
            : combinedError?.message || "Failed to load global market data"} */}
          {globalSnapshotError || "Failed to load global market data"}
        </div>
      )}

      {/* {!combinedLoading && !quote && !combinedError && (
        <div className="stockpro-card">
          No global quote was returned for {companyCode}.
        </div>
      )} */}

      {globalSnapshot && (
        <div className="stockpro-page">
          {/* ================= HEADER ================= */}
          {(!isMobile || mobileTab === "details") && (
            <section className="stockpro-header">
              <div className="stockpro-price-title">
                <div className="stockpro-head-block">
                  <div className="stockpro-title-block">
                    <h1>{companyName}</h1>
                    <p className="stockpro-symbol stock-tag">{companyCode}</p>
                    <span>
                      {quote?.fullExchangeName ||
                        quote?.exchange ||
                        "Global Market"}
                    </span>
                  </div>

                  <div className="stockpro-price-block">
                    <h2>
                      {currency} {formatPrice(lastPrice)}
                    </h2>
                    <p
                      className={
                        percentChange > 0
                          ? "stockpro-green"
                          : percentChange < 0
                            ? "stockpro-red"
                            : "stockpro-neutral"
                      }
                    >
                      {percentChange > 0 ? "▲" : percentChange < 0 ? "▼" : "•"}{" "}
                      {currency}{" "}
                      {formatPrice(
                        priceChange === null ? null : Math.abs(priceChange),
                      )}
                      <span> ({formatPercent(percentChange)})</span>
                    </p>
                  </div>
                </div>

                <div className="stockpro-header-metrics">
                  {[
                    ["LTP", lastPrice],
                    ["Open", open],
                    ["High", high],
                    ["Low", low],
                    ["Prev Close", previousClose],
                    ["Volume", volume, true],
                  ].map(([label, value, isVolume]) => (
                    <div className="stockpro-metric" key={label}>
                      <span>{label}</span>
                      <b>
                        {isVolume
                          ? formatVolume(value)
                          : `${currency} ${formatPrice(value)}`}
                      </b>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {/* ================= SIGNAL STRIP ================= */}
          {/* {(!isMobile || mobileTab === "details") && (
            <section className="stockpro-signal-strip">
              <div className="stockpro-insight-heading">
                <div>
                  <h3>Quant Kubera Global Insights</h3>
                  <p>{activeInsight.result}</p>
                </div>

                <div className="stockpro-tabs">
                  <button
                    className={timeFrame === "min" ? "active" : ""}
                    onClick={() => setTimeFrame("min")}
                  >
                    Minute
                  </button>
                  <button
                    className={timeFrame === "day" ? "active" : ""}
                    onClick={() => setTimeFrame("day")}
                  >
                    Daily
                  </button>
                </div>
              </div>

              <div className="signal-strip-main">
                <div className="signal-strip-inner">
                  {[
                    ["Momentum", activeInsight.prediction],
                    [
                      "RSI",
                      latestRSI === null || latestRSI === undefined
                        ? "—"
                        : latestRSI.toFixed(2),
                    ],
                    [
                      "MACD",
                      latestMACDRow?.macd === null ||
                      latestMACDRow?.macd === undefined
                        ? "—"
                        : latestMACDRow.macd.toFixed(2),
                    ],
                    [
                      "MACD Signal",
                      latestMACDRow?.signal === null ||
                      latestMACDRow?.signal === undefined
                        ? "—"
                        : latestMACDRow.signal.toFixed(2),
                    ],
                    ["Target Upside", formatPercent(projectedChange)],
                  ].map(([label, value]) => (
                    <div className="stockpro-signal-chip" key={label}>
                      <span>{label}</span>
                      <b
                        className={
                          label === "Momentum"
                            ? activeInsight.className
                            : getSignalClass(value)
                        }
                      >
                        {value ?? "—"}
                      </b>
                    </div>
                  ))}
                </div>

                <div className="stockpro-actions">
                  <button
                    type="button"
                    onClick={() => loadGlobalData({ silent: true })}
                    disabled={isRefreshing}
                  >
                    {isRefreshing ? "Refreshing..." : "Refresh"}
                  </button>
                </div>
              </div>

             


                                
            </section>
          )} */}
          {/* ================= QK INSIGHTS ================= */}

          {(!isMobile || mobileTab === "details") && (
            <section className="stockpro-signal-strip">
              <div className="stockpro-insight-heading">
                <div>
                  <h3>Quant Kubera Global Insights</h3>
                </div>
              </div>

              <div className="signal-strip-main">
                <div className="signal-strip-inner">
                  {[
                    {
                      label: "VWAP",
                      value: vwapSignal,
                      tooltip: TOOLTIPS?.vwapMomentum,
                    },

                    {
                      label: "RSI MACD",
                      value: prediction,
                      tooltip: TOOLTIPS?.rsiMacdSignal,
                    },

                    {
                      label: "UT Bot",
                      value: utSignal,
                      tooltip: TOOLTIPS?.utBot,
                    },

                    {
                      label: "Bollinger Band",

                      value:
                        bbSignal === "BUY"
                          ? "Bullish"
                          : bbSignal === "SELL"
                            ? "Bearish"
                            : bbSignal || "Neutral",

                      tooltip: TOOLTIPS?.bbSignal,
                    },

                    {
                      label: "Smart Money",

                      value: smartMoney?.signal,

                      tooltip: TOOLTIPS?.smartMoney,
                    },
                  ].map((item) => (
                    <div className="stockpro-signal-chip" key={item.label}>
                      <span>
                        {item.label}

                        <InfoTooltip text={item.tooltip} />
                      </span>

                      <b
                        className={
                          item.value === "BUY" ||
                          item.value === "Bullish" ||
                          item.value === "Accumulation" ||
                          item.value?.includes?.("Bullish")
                            ? "stockpro-bull"
                            : item.value === "SELL" ||
                                item.value === "Bearish" ||
                                item.value === "Distribution" ||
                                item.value?.includes?.("Bearish")
                              ? "stockpro-bear"
                              : "stockpro-neutral"
                        }
                      >
                        {item.value || "Neutral"}
                      </b>
                    </div>
                  ))}
                </div>

                <div className="stockpro-actions">
                  <button
                    type="button"
                    onClick={() =>
                      loadGlobalData({
                        silent: true,
                      })
                    }
                    disabled={isRefreshing}
                  >
                    {isRefreshing ? "Refreshing..." : "Refresh"}
                  </button>
                </div>
              </div>
            </section>
          )}

          {/* ================= MOBILE TABS ================= */}
          {isMobile && (
            <div className="stock-mobile-tabs">
              {[
                ["details", "Details"],
                ["technical", "Technical"],
                ["charts", "Charts"],
                ["fundamentals", "Fundamentals"],
              ].map(([key, label]) => (
                <button
                  key={key}
                  className={mobileTab === key ? "active" : ""}
                  onClick={() => setMobileTab(key)}
                >
                  {label}
                </button>
              ))}
            </div>
          )}

          {/* ================= MAIN GRID ================= */}
          <section className="stockpro-grid">
            <div className="stockpro-main">
              {/* Technical Overview + Key Levels */}
              {(!isMobile || mobileTab === "technical") && (
                <div className="stockpro-two-col">
                  {(!isMobile || mobileTab === "technical") && (
                    <div className="stockpro-two-col">
                      {/* =========================================
        QK TECHNICAL SCORE
    ========================================== */}
                      <section className="stockpro-card stockpro-score-section mobile-qk-score">
                        <div className="stockpro-card-head">
                          <h3>QK Technical Score</h3>
                        </div>

                        <section
                          className="stockpro-overall-hero"
                          style={{
                            "--card-bg": overallTheme.bg,
                            "--card-border": overallTheme.border,
                            "--score-color": overallTheme.circle,
                            "--text-color": overallTheme.text,
                          }}
                        >
                          {/* GAUGE */}
                          <div>
                            <OverallScoreGauge score={overallScore} />
                          </div>

                          {/* SUMMARY */}
                          <div className="overall-content">
                            <h2>{overallSummary.title}</h2>

                            <p>{overallSummary.desc}</p>

                            <div className="qk-score-tabs">
                              {[
                                {
                                  label: "UT Bot",
                                  score: utScore,
                                },
                                {
                                  label: "Bollinger Band",
                                  score: bbScore,
                                },
                                {
                                  label: "VWAP",
                                  score: vwapScore,
                                },
                                {
                                  label: "Smart Money",
                                  score: smartScore,
                                },
                                {
                                  label: "RSI MACD",
                                  score: rsiScore,
                                },
                              ].map((item) => {
                                const theme = getScoreTheme(item.score);

                                return (
                                  <div
                                    key={item.label}
                                    className="qk-score-tab"
                                    style={{
                                      "--tab-bg": theme.bg,
                                      "--tab-border": theme.border,
                                      "--tab-color": theme.text,
                                    }}
                                  >
                                    <b>{item.label}</b>

                                    <small>{item.score}/100</small>
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          {/* SCORE LEGEND */}
                          <div className="score-range-guide">
                            <div>
                              <span className="range-dot strong-bull" /> 80-100
                              Strong Bullish
                            </div>

                            <div>
                              <span className="range-dot bull" /> 60-79 Bullish
                            </div>

                            <div>
                              <span className="range-dot neutral" /> 40-59
                              Neutral
                            </div>

                            <div>
                              <span className="range-dot bear" /> 20-39 Bearish
                            </div>

                            <div>
                              <span className="range-dot strong-bear" /> 0-19
                              Strong Bearish
                            </div>
                          </div>
                        </section>
                      </section>

                      {/* =========================================
        TECHNICAL SNAPSHOT
    ========================================== */}

                      <section className="stockpro-card stockpro-tech-card mobile-technical">
                        <div className="stockpro-card-head">
                          <h3>Technical Snapshot</h3>

                          <span>
                            {timeFrame === "min" ? "Intraday" : "Daily"}
                          </span>
                        </div>

                        <div className="stockpro-tech-grid">
                          {/* =====================================
            1. MOMENTUM & EXHAUSTION
        ====================================== */}

                          <div className="stockpro-tech-block">
                            <div className="stockpro-tech-block-head">
                              <h4>Momentum & Exhaustion</h4>

                              <div className="stockpro-tabs small">
                                <button
                                  className={
                                    timeFrame === "min" ? "active" : ""
                                  }
                                  onClick={() => setTimeFrame("min")}
                                >
                                  Min
                                </button>

                                <button
                                  className={
                                    timeFrame === "day" ? "active" : ""
                                  }
                                  onClick={() => setTimeFrame("day")}
                                >
                                  Day
                                </button>
                              </div>
                            </div>

                            <div
                              className="stockpro-smart-hero"
                              style={{
                                background: rsiTheme.bg,
                                border: `1px solid ${rsiTheme.border}`,
                              }}
                            >
                              <div
                                className="stockpro-smart-score"
                                style={{
                                  borderColor: rsiTheme.circle,

                                  color: rsiTheme.circle,
                                }}
                              >
                                {rsiScore}
                              </div>

                              <div>
                                <span>RSI & MACD SCORE</span>

                                <h3
                                  style={{
                                    color: rsiTheme.text,
                                  }}
                                >
                                  {scoreData?.rsiMacdLabel ||
                                    displayPrediction ||
                                    "Neutral"}
                                </h3>

                                <p>
                                  {displayPredictionResult ||
                                    "No momentum analysis available"}
                                </p>
                              </div>
                            </div>

                            <div className="stockpro-mini-grid">
                              <div className="stockpro-metric">
                                <span>RSI</span>
                                <b>{displayRSI?.toFixed?.(2) ?? "—"}</b>
                              </div>

                              <div className="stockpro-metric">
                                <span>MACD</span>
                                <b>{displayMACD?.toFixed?.(2) ?? "—"}</b>
                              </div>

                              <div className="stockpro-metric">
                                <span>Volume</span>
                                <b>{formatVolume(volume)}</b>
                              </div>
                            </div>
                          </div>

                          {/* =====================================
            2. SMART MONEY
        ====================================== */}

                          <div className="stockpro-tech-block smart">
                            <div className="stockpro-tech-block-head">
                              <h4>Smart Money Flow</h4>

                              <div className="stockpro-tabs small">
                                <button className="active">Intraday</button>

                                {/* no EOD smart money yet */}
                                <button disabled>EOD</button>
                              </div>
                            </div>

                            <div
                              className="stockpro-smart-hero"
                              style={{
                                background: smartTheme.bg,
                                border: `1px solid ${smartTheme.border}`,
                              }}
                            >
                              <div
                                className="stockpro-smart-score"
                                style={{
                                  borderColor: smartTheme.circle,

                                  color: smartTheme.circle,
                                }}
                              >
                                {smartScore}
                              </div>

                              <div>
                                <span>SMART MONEY SCORE</span>

                                <h3
                                  style={{
                                    color: smartTheme.text,
                                  }}
                                >
                                  {smartMoney?.status ||
                                    smartMoney?.signal ||
                                    "Neutral"}
                                </h3>

                                <p>
                                  {smartMoney?.conclusion ||
                                    "Smart money data unavailable"}
                                </p>
                              </div>
                            </div>

                            <div className="stockpro-mini-grid">
                              <div className="stockpro-metric">
                                <span>CMF</span>

                                <b>{smartMoney?.cmf?.value ?? "—"}</b>
                              </div>

                              <div className="stockpro-metric">
                                <span>RVOL</span>

                                <b>
                                  {smartMoney?.rvol?.value != null
                                    ? `${smartMoney.rvol.value}x`
                                    : "—"}
                                </b>
                              </div>

                              <div className="stockpro-metric">
                                <span>Score</span>

                                <b>{smartScore}/100</b>
                              </div>
                            </div>
                          </div>

                          {/* =====================================
            3. VALUE BENCHMARK / VWAP
        ====================================== */}

                          <section className="stockpro-card">
                            <div className="stockpro-card-head">
                              <h3>Value Benchmark</h3>

                              <span>{quoteTime || "Live Snapshot"}</span>
                            </div>

                            <div className="vwap-score-box">
                              <div className="stockpro-vwap-box">
                                <span>{vwapSignal || "VWAP Signal"}</span>

                                <h2>
                                  VWAP {currency} {formatPrice(vwap)}
                                </h2>

                                <p>
                                  {lastPrice !== null && vwap !== null
                                    ? `LTP is ${
                                        lastPrice >= vwap ? "above" : "below"
                                      } VWAP`
                                    : "Waiting for VWAP data"}
                                </p>
                              </div>

                              <div
                                className="stockpro-smart-hero"
                                style={{
                                  background: vwapTheme.bg,

                                  border: `1px solid ${vwapTheme.border}`,
                                }}
                              >
                                <div
                                  className="stockpro-smart-score"
                                  style={{
                                    borderColor: vwapTheme.circle,

                                    color: vwapTheme.circle,
                                  }}
                                >
                                  {vwapScore}
                                </div>

                                <div>
                                  <span>VWAP SCORE</span>

                                  <h3
                                    style={{
                                      color: vwapTheme.text,
                                    }}
                                  >
                                    {scoreData?.vwapLabel ||
                                      vwapSignal ||
                                      "Neutral"}
                                  </h3>
                                </div>
                              </div>
                            </div>

                            <div className="stockpro-mini-grid">
                              <div className="stockpro-metric">
                                <span>LTP - VWAP</span>

                                <b
                                  className={
                                    vwapDiff == null
                                      ? "stockpro-neutral"
                                      : vwapDiff >= 0
                                        ? "stockpro-green"
                                        : "stockpro-red"
                                  }
                                >
                                  {vwapDiff != null
                                    ? `${
                                        vwapDiff >= 0 ? "+" : ""
                                      }${vwapDiff.toFixed(2)} (${
                                        vwapPercent >= 0 ? "+" : ""
                                      }${Number(vwapPercent).toFixed(2)}%)`
                                    : "—"}
                                </b>
                              </div>

                              <div className="stockpro-metric">
                                <span>Stop Loss</span>

                                <b>
                                  {vwapStopLoss
                                    ? `${currency} ${formatPrice(vwapStopLoss)}`
                                    : "—"}
                                </b>
                              </div>

                              <div className="stockpro-metric">
                                <span>Target</span>

                                <b>
                                  {nearestLevels?.resistance != null
                                    ? `${currency} ${formatPrice(
                                        nearestLevels.resistance,
                                      )}`
                                    : "—"}
                                </b>
                              </div>

                              <div className="stockpro-metric">
                                <span>Exit</span>

                                <b>—</b>
                              </div>
                            </div>
                          </section>

                          {/* =====================================
            4. TREND + VOLATILITY
        ====================================== */}

                          <section className="stockpro-card">
                            <div className="stockpro-tech-block-head">
                              <h4>Trend & Volatility Execution</h4>
                            </div>

                            <div className="par-smart-hero">
                              {/* UT BOT */}

                              <div
                                className="stockpro-smart-hero"
                                style={{
                                  background: utTheme.bg,

                                  border: `1px solid ${utTheme.border}`,
                                }}
                              >
                                <div
                                  className="stockpro-smart-score"
                                  style={{
                                    borderColor: utTheme.circle,

                                    color: utTheme.circle,
                                  }}
                                >
                                  {utScore}
                                </div>

                                <div>
                                  <span>UT BOT SCORE</span>

                                  <h3
                                    style={{
                                      color: utTheme.text,
                                    }}
                                  >
                                    {getUTBotScore(utSignal)?.label}
                                  </h3>
                                </div>
                              </div>

                              {/* BOLLINGER */}

                              <div
                                className="stockpro-smart-hero"
                                style={{
                                  background: bbTheme.bg,

                                  border: `1px solid ${bbTheme.border}`,
                                }}
                              >
                                <div
                                  className="stockpro-smart-score"
                                  style={{
                                    borderColor: bbTheme.circle,

                                    color: bbTheme.circle,
                                  }}
                                >
                                  {bbScore}
                                </div>

                                <div>
                                  <span>BB SIGNAL SCORE</span>

                                  <h3
                                    style={{
                                      color: bbTheme.text,
                                    }}
                                  >
                                    {getBBScore(bbSignal)?.label}
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </section>
                    </div>
                  )}
                  <section className="stockpro-card">
                    <div className="stockpro-card-head">
                      <h3>Technical Overview</h3>
                      <b className={activeInsight.className}>
                        {activeInsight.prediction}
                      </b>
                    </div>

                    <div className="stockpro-level-list">
                      <div>
                        <span>RSI</span>
                        <b>{latestRSI?.toFixed?.(2) || "—"}</b>
                      </div>
                      <div>
                        <span>MACD</span>
                        <b>{latestMACDRow?.macd?.toFixed?.(4) || "—"}</b>
                      </div>
                      <div>
                        <span>Signal</span>
                        <b>{latestMACDRow?.signal?.toFixed?.(4) || "—"}</b>
                      </div>
                      <div>
                        <span>Histogram</span>
                        <b
                          className={
                            safeNumber(latestMACDRow?.histogram) === null
                              ? "stockpro-neutral"
                              : safeNumber(latestMACDRow?.histogram) >= 0
                                ? "stockpro-green"
                                : "stockpro-red"
                          }
                        >
                          {latestMACDRow?.histogram?.toFixed?.(4) || "—"}
                        </b>
                      </div>
                    </div>
                  </section>

                  <section className="stockpro-card">
                    <div className="stockpro-card-head">
                      <h3>Key Levels</h3>
                    </div>

                    <div className="stockpro-level-list">
                      <div>
                        <span>Nearest Resistance</span>
                        <b className="stockpro-red">
                          {nearestLevels.resistance !== null
                            ? `${currency} ${formatPrice(nearestLevels.resistance)}`
                            : "—"}
                        </b>
                      </div>
                      <div>
                        <span>Nearest Support</span>
                        <b className="stockpro-green">
                          {nearestLevels.support !== null
                            ? `${currency} ${formatPrice(nearestLevels.support)}`
                            : "—"}
                        </b>
                      </div>
                      <div>
                        <span>Forecast Price</span>
                        <b>
                          {currency} {formatPrice(targetPriceValue)}
                        </b>
                      </div>
                      <div>
                        <span>Projected Upside</span>
                        <b
                          className={
                            projectedChange === null
                              ? "stockpro-neutral"
                              : projectedChange >= 0
                                ? "stockpro-green"
                                : "stockpro-red"
                          }
                        >
                          {formatPercent(projectedChange)}
                        </b>
                      </div>
                    </div>
                  </section>
                </div>
              )}

              {/* Pivot Levels */}
              {(!isMobile || mobileTab === "technical") && (
                <section className="stockpro-card">
                  <div className="stockpro-card-head">
                    <h3>Pivot Levels</h3>
                    <div className="stockpro-tabs">
                      <button
                        className={resistTimeFrame === "day" ? "active" : ""}
                        onClick={() => setResistTimeFrame("day")}
                      >
                        Daily
                      </button>
                      <button
                        className={resistTimeFrame === "week" ? "active" : ""}
                        onClick={() => setResistTimeFrame("week")}
                      >
                        Weekly
                      </button>
                    </div>
                  </div>

                  <div className="stockpro-table-wrap">
                    <table className="stockpro-table">
                      <thead>
                        <tr>
                          <th>Level</th>
                          <th>Priority</th>
                          <th>Status</th>
                          <th>Classic</th>
                          <th>Fibonacci</th>
                          <th>Camarilla</th>
                          <th>Woodie</th>
                          <th>DM</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pivotLevels.map((level) => {
                          const classic = activePivots?.classic?.[level.key];
                          const fibonacci = activePivots?.fib?.[level.key];
                          const camarilla = activePivots?.cam?.[level.key];
                          const woodie = activePivots?.woodie?.[level.key];
                          const demark = activePivots?.demark?.[level.key];
                          return (
                            <tr
                              key={level.key}
                              className={
                                level.key === "P" ? "stockpro-pivot-row" : ""
                              }
                            >
                              <td>
                                <b>{level.key}</b> - {level.label}
                              </td>
                              <td>{getLevelPriority(classic)}</td>
                              <td>
                                <span
                                  className={
                                    safeNumber(classic) === null
                                      ? "stockpro-neutral"
                                      : safeNumber(classic) > lastPrice
                                        ? "stockpro-red"
                                        : "stockpro-green"
                                  }
                                >
                                  {getLevelStatus(classic)}
                                </span>
                              </td>
                              <td>{formatPrice(classic)}</td>
                              <td>{formatPrice(fibonacci)}</td>
                              <td>{formatPrice(camarilla)}</td>
                              <td>{formatPrice(woodie)}</td>
                              <td>{formatPrice(demark)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </section>
              )}

              {/* Return Performance */}
              {(!isMobile || mobileTab === "technical") && (
                <section className="stockpro-card">
                  <div className="stockpro-card-head">
                    <h3>Return Performance</h3>
                  </div>
                  <div className="stockpro-return-grid">
                    {returnRows.map((item) => (
                      <div className="stockpro-return-item" key={item.label}>
                        <span>{item.label}</span>
                        <b
                          className={
                            item.value === null
                              ? "stockpro-neutral"
                              : item.value >= 0
                                ? "stockpro-green"
                                : "stockpro-red"
                          }
                        >
                          {formatPercent(item.value)}
                        </b>
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {/* Moving Averages */}
              {(!isMobile || mobileTab === "technical") && (
                <section className="stockpro-card mobile-moving-average">
                  <div className="stockpro-card-head">
                    <h3>Moving Averages</h3>
                    <span>
                      Buy {movingAverageSummary?.finalBuy || 0} / Sell{" "}
                      {movingAverageSummary?.finalSell || 0}
                    </span>
                  </div>

                  <div className="stockpro-table-wrap">
                    <Gauge
                      buy={movingAverageSummary?.finalBuy}
                      sell={movingAverageSummary?.finalSell}
                    />

                    <div className="mobile-ma-table-scroll">
                      <table className="stockpro-table">
                        <thead>
                          <tr>
                            <th>Period</th>
                            <th>SMA</th>
                            <th>SMA Signal</th>
                            <th>EMA</th>
                            <th>EMA Signal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {movingAverageRows.length > 0 ? (
                            movingAverageRows.map((row) => (
                              <tr key={row.name}>
                                <td>{row.name}</td>
                                <td>
                                  {row.smaValue !== null
                                    ? row.smaValue.toFixed(2)
                                    : "—"}
                                </td>
                                <td>
                                  <span
                                    className={
                                      row.smaTrend === "Buy"
                                        ? "stockpro-green"
                                        : row.smaTrend === "Sell"
                                          ? "stockpro-red"
                                          : "stockpro-neutral"
                                    }
                                  >
                                    {row.smaTrend}
                                  </span>
                                </td>
                                <td>
                                  {row.emaValue !== null
                                    ? row.emaValue.toFixed(2)
                                    : "—"}
                                </td>
                                <td>
                                  <span
                                    className={
                                      row.emaTrend === "Buy"
                                        ? "stockpro-green"
                                        : row.emaTrend === "Sell"
                                          ? "stockpro-red"
                                          : "stockpro-neutral"
                                    }
                                  >
                                    {row.emaTrend}
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={5} style={{ textAlign: "center" }}>
                                Moving-average data is unavailable.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>
              )}

              {/* MACD Crossover History */}
              {(!isMobile || mobileTab === "technical") &&
                crossovers.length > 0 && (
                  <section className="stockpro-card mobile-macd-crossover">
                    <div className="stockpro-card-head">
                      <h3>MACD Crossover History</h3>
                      <span>{timeFrame === "min" ? "Minute" : "Daily"}</span>
                    </div>

                    <div className="stockpro-table-wrap">
                      <table className="stockpro-table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>MACD</th>
                            <th>Signal</th>
                            <th>Message</th>
                          </tr>
                        </thead>
                        <tbody>
                          {crossovers
                            .slice()
                            .reverse()
                            .slice(0, visibleCount)
                            .map((item, index) => (
                              <tr key={`${item.date}-${index}`}>
                                <td>{formatAxisDate(item.date, timeFrame)}</td>
                                <td>{item.macd?.toFixed?.(2) || "—"}</td>
                                <td>{item.signal?.toFixed?.(2) || "—"}</td>
                                <td>
                                  {item.type === "BUY"
                                    ? "Bullish crossover detected"
                                    : "Bearish crossover detected"}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>

                    {crossovers.length > visibleCount && (
                      <button
                        className="stockpro-load-btn"
                        onClick={() => setVisibleCount((prev) => prev + 8)}
                      >
                        View More
                      </button>
                    )}
                  </section>
                )}

              {intradayCandle?.data?.length > 0 && (
                <GlobalCandleChart data={intradayCandles} />
              )}
              {/* Price Chart */}
              {(!isMobile || mobileTab === "charts") &&
                selectedPriceData.length > 0 && (
                  <section className="stockpro-card">
                    <div className="stockpro-card-head">
                      <h3>Price Trend</h3>
                    </div>

                    <ResponsiveContainer width="100%" height={300}>
                      <ComposedChart
                        data={selectedPriceData}
                        syncId="global-sync"
                      >
                        <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                        <XAxis
                          dataKey="date"
                          minTickGap={32}
                          tickFormatter={(value) =>
                            formatAxisDate(value, timeFrame)
                          }
                          tick={{ fontWeight: "bold", fontSize: 10 }}
                        />
                        <YAxis
                          domain={["auto", "auto"]}
                          tick={{ fontSize: 10 }}
                        />
                        <Tooltip
                          labelFormatter={(value) =>
                            parseDate(value)?.toLocaleString("en-US") || value
                          }
                          formatter={(value) => [
                            Number(value).toFixed(2),
                            "Price",
                          ]}
                        />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="close"
                          stroke="#22c55e"
                          strokeWidth={2}
                          dot={false}
                          name="Price"
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </section>
                )}

              {/* MACD Chart */}
              {(!isMobile || mobileTab === "charts") && (
                <section className="stockpro-card">
                  <div className="stockpro-card-head">
                    <h3>MACD Line, Signal and Histogram</h3>

                    <div style={{ display: "flex", gap: 8 }}>
                      <div className="stockpro-tabs">
                        <button
                          className={timeFrame === "min" ? "active" : ""}
                          onClick={() => setTimeFrame("min")}
                        >
                          Minute
                        </button>
                        <button
                          className={timeFrame === "day" ? "active" : ""}
                          onClick={() => setTimeFrame("day")}
                        >
                          Daily
                        </button>
                      </div>

                      <select
                        value={chartInterval}
                        onChange={(event) =>
                          setChartInterval(event.target.value)
                        }
                      >
                        {timeFrame === "min" ? (
                          <>
                            <option value="1m">1 Minute</option>
                            <option value="3m">3 Minute</option>
                            <option value="5m">5 Minute</option>
                          </>
                        ) : (
                          <>
                            <option value="1d">Daily</option>
                            <option value="1w">Weekly</option>
                            <option value="1mo">Monthly</option>
                            <option value="3mo">Quarterly</option>
                          </>
                        )}
                      </select>
                    </div>
                  </div>

                  {selectedChartData.length ? (
                    <ResponsiveContainer width="100%" height={340}>
                      <ComposedChart data={selectedChartData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="date"
                          minTickGap={32}
                          tickFormatter={(value) =>
                            formatAxisDate(value, timeFrame)
                          }
                        />
                        <YAxis domain={["auto", "auto"]} />
                        <Tooltip
                          labelFormatter={(value) =>
                            parseDate(value)?.toLocaleString("en-US") || value
                          }
                        />
                        <Legend />
                        <Bar
                          dataKey="histogram"
                          name="Histogram"
                          barSize={12}
                          shape={<HistogramBar />}
                        />
                        <Line
                          type="monotone"
                          dataKey="MACD"
                          stroke="#2563eb"
                          strokeWidth={2}
                          dot={false}
                          name="MACD"
                        />
                        <Line
                          type="monotone"
                          dataKey="signal"
                          stroke="#f59e0b"
                          strokeWidth={2}
                          dot={false}
                          name="Signal"
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  ) : (
                    <p>No MACD chart data is available.</p>
                  )}
                </section>
              )}
            </div>

            {/* ================= SIDEBAR ================= */}
            <aside className="stockpro-side">
              {(!isMobile || mobileTab === "details") && (
                <>
                  <section className="stockpro-card mobile-day-range">
                    <div className="stockpro-card-head">
                      <h3>Day Range</h3>
                    </div>
                    <RangeTrack
                      low={low}
                      high={high}
                      current={lastPrice}
                      currency={currency}
                    />
                  </section>

                  <section className="stockpro-card mobile-week52">
                    <div className="stockpro-card-head">
                      <h3>52 Week Range</h3>
                    </div>
                    <RangeTrack
                      low={weekLow}
                      high={weekHigh}
                      current={lastPrice}
                      currency={currency}
                    />
                  </section>

                  {targetPriceValue !== null && (
                    <section className="stockpro-card mobile-analyst">
                      <div className="stockpro-card-head">
                        <h3>Analyst Forecast</h3>
                      </div>
                      <div className="stockpro-forecast-box">
                        <span>Target Price</span>
                        <h2>
                          {currency} {formatPrice(targetPriceValue)}
                        </h2>
                        <p
                          className={
                            projectedChange === null
                              ? ""
                              : projectedChange >= 0
                                ? "stockpro-green"
                                : "stockpro-red"
                          }
                        >
                          {projectedChange !== null
                            ? `${formatPercent(projectedChange)} expected move`
                            : "Target price unavailable"}
                        </p>
                      </div>
                    </section>
                  )}

                  <section className="stockpro-card mobile-forecast-range">
                    <div className="stockpro-card-head">
                      <h3>Forecast Range</h3>
                    </div>
                    <RangeTrack
                      low={targetLow}
                      high={targetHigh}
                      current={targetPriceValue}
                      currency={currency}
                    />
                  </section>
                </>
              )}

              {(!isMobile || mobileTab === "fundamentals") && (
                <>
                  <section className="stockpro-card mobile-fundamentals">
                    <div className="stockpro-card-head">
                      <h3>Fundamental Factors</h3>
                    </div>
                    <div className="stockpro-level-list">
                      <div>
                        <span>Projected Upside</span>
                        <b
                          className={
                            projectedChange === null
                              ? "stockpro-neutral"
                              : projectedChange >= 0
                                ? "stockpro-green"
                                : "stockpro-red"
                          }
                        >
                          {formatPercent(projectedChange)}
                        </b>
                      </div>
                      <div>
                        <span>Forecast Price</span>
                        <b>
                          {currency} {formatPrice(targetPriceValue)}
                        </b>
                      </div>
                      <div>
                        <span>Forward P/E</span>
                        <b>{statisticsData?.forwardPE?.fmt || "—"}</b>
                      </div>
                    </div>
                  </section>

                  {[
                    ["Valuation Measures", valuationRows, "mobile-valuation"],
                    [
                      "Profitability & Growth",
                      profitabilityRows,
                      "mobile-profit",
                    ],
                    ["Ownership & Risk", ownershipRows, "mobile-ownership"],
                  ].map(([title, rows, cls]) => (
                    <section className={`stockpro-card ${cls}`} key={title}>
                      <div className="stockpro-card-head">
                        <h3>{title}</h3>
                      </div>
                      <div className="stockpro-level-list">
                        {rows.map(([label, value]) => (
                          <div key={label}>
                            <span>{label}</span>
                            <b>{value || "—"}</b>
                          </div>
                        ))}
                      </div>
                    </section>
                  ))}
                </>
              )}
            </aside>
          </section>
        </div>
      )}
    </>
  );
};

// export default GlobalTest;

export default GlobalTest;
